
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8d2f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8d2f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4ACxo", function(module, exports) {

$parcel$export(module.exports, "mastheadTitleScale", () => $35786af7645e33f6$export$a97c8b9e1aa7edd8);
$parcel$export(module.exports, "centeredTitleTransform", () => $35786af7645e33f6$export$23c8cb846febe10);
$parcel$export(module.exports, "workTitleRows", () => $35786af7645e33f6$export$bc08165781f4cf58);
// Shared by the SVG gallery and canvas homepage. CSS owns the size limit.
function $35786af7645e33f6$export$a97c8b9e1aa7edd8(element, cssScale, viewWidth = 1200) {
    const maxWidth = parseFloat(getComputedStyle(element).getPropertyValue('--masthead-title-max-width')) || 960;
    return Math.min(1, maxWidth / (viewWidth * cssScale));
}
function $35786af7645e33f6$export$23c8cb846febe10(scale, x, y) {
    return `translate(${x} ${y}) scale(${scale}) translate(${-x} ${-y})`;
}
function $35786af7645e33f6$export$bc08165781f4cf58(rows, small) {
    const x = small ? 380 : 600;
    const baselines = rows.length === 1 ? [
        small ? 345 : 295
    ] : small ? [
        245,
        410
    ] : [
        205,
        385
    ];
    return rows.map((text, i)=>[
            x,
            baselines[i],
            text
        ]);
}

});

// Precomputed seamless loss contours and downhill trajectories.
// Regenerate with: node scripts/generate-loss-contours.cjs
var $163eeaf116323931$export$2e2bcd8739ae039 = {
    "name": "Broad basins",
    "contours": "M0,9.8L11.67,14.86L23.33,19.01L35,22.41L46.67,25.3L70,29.9L93.33,33.5L214.22,50.33L233.33,52.31L256.67,53.25L268.33,52.88L280,51.82L291.67,50.02L303.33,47.44L315,44L326.67,39.67L338.33,34.49L350,28.13L361.67,20.7L373.69,11.54L385.73,0M435.06,0L426.86,11.54L420,19.9L405.99,34.62L396.67,43.22L385,53.04L361.67,70.48L338.33,85.59L326.67,92.39L303.33,104.43L291.67,109.57L280,113.9L268.33,117.38L256.67,119.85L245,121.13L233.33,121.16L221.67,119.98L210,117.69L186.67,111.04L165.78,103.85L129.77,92.31L93.33,82.61L35,68.43L11.67,61.5L0,57.29M469.8,0L462.79,11.54L454.71,23.08L443.33,36.97L431.67,49.72L420,61.5L396.67,83.27L342.55,131.09L318.93,153.88L307.65,165.8L296.83,178.18L291.67,185.14L286.56,191.1L280,200.85L276.91,204.63L272.2,211.51L268.33,218.29L263.13,225.62L256.67,237.1L249.66,246.92L245,254.74L233.33,267.72L221.67,273.99L210,273.16L198.33,265.62L186.67,251.9L158.25,207.69L149.8,196.15L140.26,184.62L129.22,173.08L115.95,161.54L105,153.59L93.33,146.2L79.24,138.46L70,134.06L46.67,124.17L0,106.6M497.99,0L491.6,11.54L484.07,23.08L475.66,34.62L466.67,45.86L443.33,71.73L404.22,111.31L381.6,135.09L365.36,153.66L355.07,166.55L345.33,180L331.9,201.33L319.98,224.16L309.45,248.36L291.67,296.31L280.55,323.08L268.36,346.18L256.67,362.11L249.39,369.23L245,373.24L233.33,380.27L221.67,383.35L210,382.89L198.33,378.85L186.67,371.2L184.53,369.23L175,359.94L163.33,345.21L151.67,327.15L146.13,317.6L124.03,276.92L110.94,253.85L95.75,230.77L86.84,219.23L76.55,207.69L70,201.2L58.33,190.98L50.08,184.62L35,174.46L23.33,167.55L0,155.35M522.48,0L516.37,11.54L509.29,23.08L501.39,34.62L492.59,46.15L478.33,63.3L466.67,76.48L414.59,133.11L393.64,158.54L378.97,178.65L365.58,200.02L357.4,215.01L346.31,238.66L333.31,271.95L315.77,323.08L311.4,334.62L303.33,354.88L291.67,378.96L280,397.99L268.33,413.02L256.67,424.62L253.61,426.92L245,433.2L233.33,439.06L221.67,442.08L210,442.34L198.33,439.7L186.67,433.98L175,425.18L165.36,415.38L151.67,398.45L140,381.18L128.33,361.87L92.85,300L81.67,282.18L69.89,265.38L58.33,250.76L46.67,237.9L39.42,230.77L23.33,216.83L11.67,208.11L0,200.2M544.57,0L538.69,11.54L531.85,23.08L524.23,34.62L515.79,46.15L506.69,57.69L490,77.45L450.05,122.02L428.79,147.15L413.6,166.74L399.46,187.38L390.63,201.72L382.45,216.71L378.51,224.35L367.69,248.26L354.95,281.82L338.33,331.8L326.67,364.14L315,391.65L303.33,414.3L291.67,433L287.67,438.46L280,448.64L268.33,461.65L256.67,472.32L245,480.85L233.33,487.26L221.67,491.42L210,493.1L198.33,492.03L186.67,487.89L181.49,484.62L175,480.45L163.33,469.65L151.67,455.7L140,439L128.33,420.17L81.67,338.08L70,319.27L58.33,302.08L46.67,286.6L38.62,276.92L28.07,265.38L11.67,249.71L0,240.02M565.05,0L559.33,11.54L552.66,23.08L545.21,34.62L536.67,46.66L528.17,57.69L513.33,75.7L472.98,121.63L446.64,153.27L436.58,166.4L426.94,179.94L413.36,201.13L400.99,223.5L393.44,239.12L379.85,271.83L367.85,306.12L350,360.54L338.15,392.31L328.07,415.38L322.37,426.92L315,440.93L303.33,460.22L291.67,476.96L280,491.69L268.33,504.74L256.67,516.32L245,526.53L233.33,535.34L221.67,542.5L210,547.91L204.88,548.78L198.33,550.6L186.67,549.76L175,544.15L163.33,533.39L151.67,517.78L140,498.69L128.33,477.3L84.63,392.31L71.77,369.23L57.76,346.15L46.67,329.52L33.27,311.54L23.68,300L13.14,288.46L0,275.61M584.45,0L578.78,11.54L572.3,23.08L564.96,34.62L556.91,46.15L548.29,57.65L536.67,72.04L484.16,132.68L463.34,158.25L448.53,178.21L439.18,192.05L426.06,213.68L414.13,236.5L400.08,268.76L390.68,294.08L361.67,382.32L350,413.17L338.33,439.69L326.67,462.62L315,482.81L303.33,500.98L291.67,517.7L280,533.44L250.86,571.18L241.37,584.87L236.93,592.02L229.14,607.39L226.09,615.91L223.93,625.32L222.81,635.75L222.91,647.39L224.03,657.69L227.75,675.25L237.38,703.85L247.27,726.92L260.72,754.01L278.13,784.62L292.98,807.69L301.03,819.23L318.62,842.31L338.33,865.11L350,877.27L361.57,888.46L373.33,899.04L388.36,911.54L403.34,923.08L420,935.05L443.33,950.77L489.34,980.77L501.67,989.3L521.26,1003.85L535.13,1015.38L547.44,1026.92L558.2,1038.46L567.49,1050L575.43,1061.54L583.33,1075.6L587.53,1084.62L591.85,1096.15L595.13,1107.82L597.25,1119.23L598.38,1130.77L598.51,1142.31L597.65,1153.85L595.81,1165.38L592.96,1176.92L589.16,1188.46L584.45,1200M603.05,0L597.5,11.54L591.08,23.08L583.88,34.62L575.91,46.15L558.18,69.23L538.72,92.31L494.69,143.1L474.19,168.97L459.7,189.27L450.59,203.34L437.85,225.34L426.28,248.52L412.63,281.17L400.59,315.42L385,364.64L373.33,399.61L361.67,430.54L352.3,452.28L338.33,481.08L326.67,502.42L315,522.23L285.26,570.59L275.44,588.46L269.49,601.15L265.24,611.54L260.5,626.87L258.54,636.47L257.29,646.15L256.72,657.69L257.08,669.23L258.29,680.77L260.3,692.31L263.06,703.85L270.48,726.92L280.07,750L291.59,773.08L305.05,796.15L320.63,819.23L338.64,842.31L350,855.25L359.6,865.38L371.4,876.92L385,889.16L408.33,907.95L420,916.53L443.33,932.54L500.31,969.23L513.33,978.05L532.93,992.31L547.17,1003.85L559.87,1015.38L571.05,1026.92L580.78,1038.46L589.19,1050L596.41,1061.54L602.42,1073.08L607.38,1084.62L611.26,1096.15L614.16,1107.69L616.1,1119.23L617.07,1130.77L617.09,1142.31L616.16,1153.85L614.28,1165.38L611.46,1176.92L607.73,1188.46L603.05,1200M621.21,0L615.72,11.54L609.38,23.08L602.22,34.62L594.34,46.15L585.79,57.69L567.11,80.77L520.59,134.1L494.45,165.94L484.49,179.16L470.3,199.75L461.38,214L448.96,236.33L437.7,259.82L424.41,292.82L412.62,327.32L388.41,403.85L380.29,426.92L371.4,450L361.59,473L350,497.41L338.33,520.07L310.26,572.23L302.36,588.46L295.62,603.91L289.6,621.03L285.97,634.62L283.43,649.54L282.61,657.69L282.22,669.23L282.9,683.64L283.85,692.31L285.8,703.85L288.48,715.38L291.84,726.92L295.76,738.46L300.32,750L311.2,773.08L324.44,796.15L332,807.69L340.24,819.23L349.2,830.77L358.97,842.31L369.61,853.85L385,868.93L396.67,879.33L420,897.96L439,911.54L455,922.24L501.67,951.83L525,967.15L544.04,980.77L558.6,992.31L571.67,1003.86L583.19,1015.38L595,1029.03L602.17,1038.46L609.83,1050L618.33,1065.54L621.88,1073.08L626.4,1084.62L629.99,1096.15L632.62,1107.69L634.35,1119.23L635.19,1130.77L635.13,1142.31L634.17,1153.85L632.3,1165.38L629.52,1176.92L625.81,1188.46L621.21,1200M639.12,0L633.69,11.54L627.4,23.08L620.3,34.62L603.9,57.69L585.2,80.77L530.13,143.54L509.25,169.03L499.26,182.24L484.96,202.71L476.02,216.94L467.57,231.66L459.56,246.82L448.58,270.57L435.61,303.9L426.85,329.85L399.37,418.05L385,458.2L373.93,485.2L366.77,501.2L330.35,576.92L318.94,603.89L312.42,623.08L309.34,634.62L307.02,646.15L305.46,657.69L304.66,670.54L304.66,680.77L305.4,692.31L307.69,708.15L312.04,726.92L315.67,738.46L319.94,750L324.89,761.54L330.51,773.08L336.81,784.62L343.82,796.15L351.56,807.69L360.1,819.23L369.51,830.77L379.85,842.31L396.67,859L417.39,876.92L431.67,887.96L448.62,900L465.98,911.54L521.08,946.15L536.67,956.4L554.85,969.23L569.69,980.77L583.03,992.31L595,1003.96L606.67,1016.94L614.59,1026.92L622.65,1038.46L629.67,1050L635.65,1061.54L641.67,1075.62L644.89,1084.62L648.19,1096.15L650.64,1107.69L652.24,1119.23L653,1130.77L652.89,1142.31L651.92,1153.85L650.06,1165.38L645.98,1181.19L643.67,1188.46L639.12,1200M657.03,0L651.64,11.54L644,25.38L638.31,34.62L630.45,46.15L621.89,57.69L603.07,80.77L539.4,152.71L523.74,171.83L508.75,191.62L494.68,212.32L485.87,226.69L477.6,241.58L469.79,256.93L459.06,280.93L446.39,314.56L437.82,340.7L410.81,429.37L396.67,469.92L382.51,505.23L345.89,588.46L337.32,611.54L332.21,628.56L328.25,646.15L326.56,657.59L325.61,668.19L325.27,680.77L325.75,692.31L326.99,703.85L329.63,718.31L331.65,726.92L335.09,738.46L339.26,750L344.16,761.54L349.79,773.08L356.22,784.62L363.43,796.15L373.33,810.09L380.51,819.23L390.49,830.77L401.56,842.31L413.82,853.85L427.34,865.38L443.33,877.77L458.42,888.46L475.84,900L525,930.59L548.33,945.62L565.62,957.69L583.33,971.39L595,981.44L606.39,992.31L617.15,1003.85L630,1019.83L641.67,1037.13L648.92,1050L654.47,1061.54L659.17,1073.08L663.06,1084.62L666.15,1096.15L668.45,1107.69L669.96,1119.23L670.67,1130.77L670.56,1142.31L669.6,1153.85L667.79,1165.38L665.09,1176.92L662.34,1185.83L657.03,1200M675.14,0L669.82,11.54L659.74,29.41L648.63,46.15L640,57.69L630.74,69.23L610.8,92.31L575.6,130.81L553.77,155.38L537.98,174.38L522.87,194.05L508.65,214.6L499.76,228.88L491.36,243.66L483.45,258.91L476.1,274.71L469.24,291L457.49,323.08L448.49,351.26L424.77,431.65L410.42,475.14L396.67,511.63L369.77,576.92L357.11,611.54L350.7,634.62L348.3,646.15L345.82,665.1L345.07,680.77L345.42,692.31L346.53,703.85L348.38,715.38L351,726.92L354.39,738.46L358.56,750L363.53,761.54L369.34,773.08L375.99,784.62L385,798.16L392.11,807.69L401.71,819.23L412.45,830.77L424.44,842.31L437.77,853.85L455,867.24L468.64,876.92L486.08,888.46L536.67,919.73L560,934.66L576.6,946.15L595,960.24L606.67,970.19L617.91,980.77L628.89,992.31L641.67,1007.73L647.36,1015.38L655.07,1026.92L661.87,1038.46L667.84,1050L673.01,1061.54L677.42,1073.08L681.1,1084.62L684.04,1096.15L686.25,1107.69L687.71,1119.23L688.41,1130.77L688.33,1142.31L687.43,1153.85L686.05,1163.12L683.08,1176.92L681.63,1181.83L679.57,1188.46L675.14,1200M693.77,0L688.41,11.62L680.18,26.55L671.08,40.62L658.5,57.69L649.1,69.23L628.75,92.31L590.11,133.63L568.05,157.96L552.07,176.77L536.82,196.31L522.43,216.69L513.43,230.87L504.9,245.51L493.11,268.46L482.49,292.57L471.12,323.08L461.63,352.71L438.47,433.65L424.75,477.78L412.75,512.06L383.81,588.46L376.14,611.54L369.99,634.62L367.68,646.15L365.96,657.69L364.88,669.23L364.49,680.77L364.81,692.31L365.89,703.85L367.74,715.38L370.38,726.92L373.33,736.83L378.14,750L385,764.83L389.39,773.08L396.4,784.62L408.33,801.08L420,814.82L431.67,826.84L443.33,837.56L455,847.28L466.67,856.23L479.51,865.38L496.98,876.92L553.24,911.54L571.67,923.34L588.06,934.62L606.67,948.77L618.33,958.64L629.69,969.23L640.82,980.77L653.33,995.54L659.67,1003.85L667.63,1015.38L674.73,1026.92L681.04,1038.46L686.62,1050L691.49,1061.54L695.69,1073.08L699.21,1084.62L702.07,1096.15L704.26,1107.69L705.74,1119.23L706.49,1130.77L706.49,1142.31L705.68,1153.85L704.04,1165.38L701.52,1176.92L698.1,1188.46L693.77,1200M713.21,0L705.27,16.76L696.7,31.35L686.54,46.15L677.21,58.23L666.64,70.85L647.2,92.31L604.66,136.48L582.3,160.52L566.12,179.13L550.66,198.45L540.83,211.81L526.96,232.7L518.31,247.23L506.35,270.01L499.04,285.86L492.25,302.23L480.65,334.62L470.13,369.23L449.45,444.51L438.91,480.24L427.55,515.16L405.77,576.92L398.15,600L391.61,623.08L386.76,646.15L385.14,657.69L384.14,669.23L383.81,680.77L384.2,692.31L385.34,703.85L387.3,715.38L390.08,726.92L393.71,738.46L398.24,750L403.75,761.54L408.33,769.77L417.83,784.62L426.61,796.15L436.63,807.69L448.03,819.23L460.91,830.77L475.34,842.31L490,852.92L513.33,868.24L560,896.68L583.47,911.54L600.3,923.08L618.33,936.74L629.54,946.15L641.67,957.37L653.33,969.4L663.22,980.77L672.25,992.31L680.39,1003.85L687.71,1015.38L694.31,1026.92L700.21,1038.46L705.49,1050L710.13,1061.54L714.19,1073.08L717.65,1084.62L720.48,1096.15L722.68,1107.69L724.24,1119.23L725.12,1130.77L725.26,1142.31L724.6,1153.85L723.1,1165.38L720.76,1176.92L717.49,1188.46L713.21,1200M734.02,0L728.9,11.54L718.5,29.83L707.15,46.15L693.59,62.89L682.68,75.18L666.41,92.31L618.33,140.43L602.21,157.13L580.18,181.49L564.49,200.59L550.66,219.23L540.43,234.49L527.47,256.29L516.85,276.92L508.58,295.3L502.07,311.54L490.18,346.15L480.15,380.77L460.54,455.48L450.39,491.6L416.28,600L410.26,623.08L405.81,646.15L404.36,657.69L403.52,669.23L403.35,680.77L403.89,692.31L405.21,703.85L407.34,715.38L410.36,726.92L414.33,738.46L420,751.55L425.24,761.54L431.67,772.08L440.66,784.62L450.34,796.15L461.46,807.69L474.13,819.23L488.43,830.77L501.67,840.38L525,855.77L571.67,884.07L595,898.76L613.65,911.54L630,923.92L641.67,933.68L653.33,944.42L666.25,957.69L676.29,969.23L685.37,980.77L700,1002.16L707.87,1015.38L714.04,1026.92L724.68,1050L729.22,1061.54L736.66,1084.62L739.6,1096.15L741.94,1107.69L743.66,1119.23L744.72,1130.77L745.08,1142.31L744.68,1153.85L743.45,1165.38L741.31,1176.92L738.19,1188.46L734.02,1200M757.08,0L750.22,15.06L741.64,29.64L729.74,46.15L716.21,62.18L693.51,85.89L641.67,135.35L618.33,158.34L599.83,177.85L583.33,196.72L568.24,215.85L553.92,236.29L540.74,257.87L530.63,276.92L520.08,300L511.68,321.44L503.32,346.15L496.49,369.23L490,393.52L474.19,457.44L464.65,494.16L440.8,576.92L431.6,611.48L426.86,634.62L425.13,646.15L423.92,657.69L423.31,669.23L423.37,680.77L424.17,692.31L425.78,703.85L428.24,715.38L431.6,726.92L436.05,738.46L443.33,753.25L448.21,761.54L455,771.53L465.45,784.62L476.34,796.15L488.85,807.69L501.67,818.1L513.33,826.65L536.79,842.31L606.67,884.98L628.54,900L643.61,911.54L653.33,919.67L665,930.34L680.35,946.15L690.28,957.69L699.3,969.23L707.54,980.77L715.08,992.31L728.38,1015.38L739.63,1038.46L744.55,1050L753.11,1073.08L759.78,1096.15L762.41,1107.69L764.46,1119.23L765.88,1130.77L766.62,1142.31L766.6,1153.85L765.74,1165.38L763.94,1176.92L761.07,1188.46L757.08,1200M784.27,0L780.02,9.91L776.12,17.59L767.08,31.73L755.83,46.15L745.48,57.69L728.76,74.59L716.77,85.81L665,131.81L641.67,153.26L618.33,176.29L597.71,198.83L582.06,217.97L567.48,238.16L557.41,253.85L544.51,276.92L533.6,300L524.36,323.08L513.04,357.41L503.58,392.31L481.33,487.58L452.91,600L448.22,623.08L446.37,634.62L444.08,657.69L443.8,669.23L444.21,680.77L445.4,692.31L447.43,703.85L450.38,715.38L454.3,726.92L459.41,738.46L466.67,751.61L473.33,761.54L478.33,768.07L490,781.39L501.67,792.64L513.33,802.5L536.14,819.23L554.07,830.77L618.33,869.73L641.67,885.64L660.14,900L676.67,914.66L685.17,923.08L695.86,934.62L705.56,946.15L714.42,957.69L730.07,980.77L743.53,1003.85L749.6,1015.38L760.57,1038.46L765.54,1050L774.42,1073.08L778.31,1084.62L784.91,1107.69L787.54,1119.23L789.58,1130.77L790.98,1142.31L791.63,1153.85L791.44,1165.38L790.27,1176.92L787.95,1188.46L784.27,1200M821.53,0L820.28,3.58L816.46,11.54L812.51,18.97L809.74,23.08L797.27,38.5L785.76,50.2L773.62,61.28L754.74,77.22L700,120.79L664.98,149.98L641.67,171.11L618.33,194.56L601.29,213.91L586.01,233.42L571.89,254.07L559.08,276.01L547.28,300L536.67,326.13L526.22,357.69L516.96,392.31L509.07,426.92L495.82,490.37L476.6,576.92L471.92,600L468.07,623.08L466.64,634.59L465.26,657.69L465.45,669.23L466.33,680.77L468.06,692.31L470.72,703.85L474.36,715.38L479.08,726.92L485.16,738.46L492.57,750L501.67,761.72L512.26,773.08L524.87,784.62L539.56,796.15L556.19,807.69L566.9,814.52L618.33,845.29L641.67,860.07L664.75,876.67L676.67,886.31L691.74,900L703.05,911.54L711.67,921.18L723.33,935.58L739.1,957.69L753.43,980.77L759.96,992.31L777.75,1026.92L788.36,1050L798.12,1073.08L811.08,1107.69L818.13,1130.77L821.13,1142.31L824.52,1161.62L825.29,1173.91L824.77,1184.94L823.07,1194.79L821.53,1200M932.81,0L929.14,7.39L926.09,15.91L923.93,25.32L922.81,35.75L922.91,47.39L924.03,57.69L927.75,75.25L937.38,103.85L942.13,115.38L952.74,138.46L964.75,161.54L971.27,173.08L985.35,196.15L992.98,207.69L1009.56,230.77L1028.27,253.85L1038.58,265.38L1050,277.27L1061.57,288.46L1073.33,299.04L1096.67,318.06L1119.38,334.62L1143.33,350.77L1189.34,380.77L1213.33,397.79L1225,406.87L1236.67,416.77L1247.44,426.92L1258.2,438.46L1267.49,450L1275.43,461.54L1282.11,473.08L1287.53,484.62L1291.85,496.15L1295.13,507.82L1297.25,519.23L1298.38,530.77L1298.51,542.31L1297.65,553.85L1295.81,565.38L1292.96,576.92L1289.16,588.46L1284.45,600L1278.78,611.54L1271.67,624.09L1256.91,646.15L1239,669.23L1184.16,732.68L1163.34,758.25L1148.53,778.21L1139.18,792.05L1126.06,813.68L1114.13,836.5L1100.08,868.76L1090.68,894.08L1061.67,982.32L1050,1013.17L1038.33,1039.69L1026.67,1062.62L1015,1082.81L1003.33,1100.98L991.67,1117.7L980,1133.44L950.86,1171.18L939.09,1188.46L932.81,1200M969.98,0L965.24,11.54L961.49,23.08L958.86,34.62L957.29,46.15L956.72,57.69L957.08,69.23L958.29,80.77L960.3,92.31L963.06,103.85L966.5,115.38L974.99,138.46L985.55,161.54L998.06,184.62L1005.05,196.15L1020.63,219.23L1038.64,242.31L1048.71,253.85L1059.6,265.38L1071.4,276.92L1084.19,288.46L1108.33,307.95L1129.33,323.08L1155,340.16L1200.31,369.23L1225,386.38L1236.67,395.25L1248.33,404.86L1259.87,415.38L1271.05,426.92L1283.33,441.85L1289.19,450L1295,459.21L1302.42,473.08L1307.38,484.62L1311.26,496.15L1314.16,507.69L1316.1,519.23L1317.07,530.77L1317.09,542.31L1316.16,553.85L1314.28,565.38L1311.46,576.92L1307.73,588.46L1303.05,600L1297.5,611.54L1291.08,623.08L1283.88,634.62L1271.67,651.87L1258.18,669.23L1238.72,692.31L1194.69,743.1L1174.19,768.97L1159.7,789.27L1150.59,803.34L1137.85,825.34L1126.28,848.52L1112.63,881.17L1100.59,915.42L1085,964.64L1073.33,999.61L1061.67,1030.54L1052.3,1052.28L1038.33,1081.08L1026.67,1102.42L1015,1122.23L985.26,1170.59L975.44,1188.46L969.98,1200M997.19,0L992.78,11.54L988.97,23.08L985.97,34.62L983.86,46.15L982.61,57.69L982.22,69.23L982.64,80.77L983.85,92.31L985.8,103.85L988.48,115.38L995.76,138.46L1000.32,150L1007.52,165.68L1017.52,184.62L1024.44,196.15L1032,207.69L1040.24,219.23L1049.2,230.77L1058.97,242.31L1073.33,257.64L1085,268.93L1096.67,279.33L1120,297.96L1143.33,314.51L1210.8,357.69L1236.67,375.35L1260,393.49L1271.67,403.86L1283.19,415.38L1295,429.03L1306.67,445.12L1316.38,461.54L1321.88,473.08L1326.4,484.62L1329.99,496.15L1332.62,507.69L1334.35,519.23L1335.19,530.77L1335.13,542.31L1334.17,553.85L1332.3,565.38L1329.52,576.92L1325.81,588.46L1321.21,600L1315.72,611.54L1309.38,623.08L1302.22,634.62L1294.61,645.77L1276.67,669.23L1257.23,692.31L1209.97,746.67L1194.45,765.94L1184.49,779.16L1170.3,799.75L1161.38,814L1148.96,836.33L1137.7,859.82L1124.41,892.82L1112.62,927.32L1088.41,1003.85L1080.29,1026.92L1071.4,1050L1061.59,1073L1050,1097.41L1038.33,1120.07L1010.26,1172.23L997.19,1200M1020.4,0L1012.42,23.08L1009.34,34.62L1007.02,46.15L1005.46,57.69L1004.68,69.23L1004.66,80.77L1005.4,92.31L1006.88,103.85L1009.11,115.38L1012.04,126.92L1016.05,139.5L1019.94,150L1024.89,161.54L1030.51,173.08L1036.81,184.62L1043.82,196.15L1051.56,207.69L1060.1,219.23L1069.51,230.77L1079.85,242.31L1096.67,259L1117.39,276.92L1132.35,288.46L1155,304.32L1221.08,346.15L1248.33,364.51L1271.67,382.41L1283.03,392.31L1295,403.96L1306.67,416.94L1318.33,432.16L1329.67,450L1335.65,461.54L1341.67,475.62L1344.89,484.62L1348.19,496.15L1350.64,507.69L1352.24,519.23L1353,530.77L1352.89,542.31L1351.92,553.85L1350.06,565.38L1347.31,576.92L1343.67,588.46L1339.12,600L1333.69,611.54L1327.4,623.08L1320.3,634.62L1312.43,646.15L1294.79,669.23L1275.26,692.31L1230.13,743.54L1219.56,756.16L1204.22,775.6L1194.38,788.95L1180.45,809.78L1171.7,824.21L1159.56,846.82L1148.58,870.57L1135.61,903.9L1126.85,929.85L1099.37,1018.05L1085,1058.2L1073.93,1085.2L1066.77,1101.2L1030.35,1176.92L1020.4,1200M1041.39,0L1033.67,23.08L1030.64,34.62L1028.25,46.15L1026.56,57.59L1025.53,69.23L1025.27,80.77L1025.75,92.31L1026.99,103.85L1028.95,115.38L1031.65,126.92L1035.09,138.46L1039.26,150L1044.16,161.54L1049.79,173.08L1056.22,184.62L1063.43,196.15L1071.5,207.69L1085,224.52L1101.56,242.31L1120,259.24L1142.19,276.92L1158.42,288.46L1178.33,301.6L1236.67,337.98L1265.62,357.69L1280.69,369.23L1294.26,380.77L1306.67,392.59L1317.15,403.85L1326.68,415.38L1335.09,426.92L1342.49,438.46L1348.92,450L1354.47,461.54L1359.17,473.08L1363.06,484.62L1366.15,496.15L1368.45,507.69L1369.96,519.23L1370.67,530.77L1370.56,542.31L1369.6,553.85L1367.28,567.64L1365.09,576.92L1362.34,585.83L1357.03,600L1351.64,611.54L1345.4,623.08L1338.31,634.62L1330.26,646.41L1312.73,669.23L1293.04,692.31L1244.74,746.45L1228.88,765.37L1218.64,778.32L1208.75,791.62L1194.68,812.32L1181.67,834.06L1169.79,856.93L1159.06,880.93L1146.39,914.56L1137.82,940.7L1110.81,1029.37L1096.67,1069.92L1082.51,1105.23L1055.74,1165.38L1041.39,1200M1061.04,0L1053.65,23.08L1048.3,46.15L1046.53,57.69L1045.45,69.23L1045.07,80.77L1045.42,92.31L1046.53,103.85L1048.38,115.38L1051,126.92L1054.39,138.46L1058.56,150L1063.53,161.54L1069.34,173.08L1075.99,184.62L1085,198.16L1092.11,207.69L1101.71,219.23L1112.45,230.77L1120,238.15L1137.77,253.85L1155,267.24L1178.33,283.42L1248.33,327.07L1276.6,346.15L1291.84,357.69L1305.59,369.23L1317.91,380.77L1328.89,392.31L1341.67,407.73L1347.36,415.38L1355.07,426.92L1365,444.44L1373.01,461.54L1377.42,473.08L1381.1,484.62L1384.04,496.15L1386.25,507.69L1387.71,519.23L1388.41,530.77L1388.33,542.31L1387.43,553.85L1385.69,565.38L1381.63,581.83L1379.57,588.46L1375.14,600L1369.82,611.54L1363.59,623.08L1356.51,634.62L1348.63,646.15L1340,657.69L1325.09,675.91L1310.8,692.31L1259.18,749.19L1243.16,767.96L1232.84,780.83L1218.01,800.78L1204.15,821.69L1195.48,836.19L1183.45,858.91L1176.1,874.71L1169.24,891L1157.49,923.08L1148.49,951.26L1124.77,1031.65L1110.42,1075.14L1096.67,1111.63L1069.77,1176.92L1061.04,1200M1079.81,0L1072.85,23.08L1067.68,46.15L1065.96,57.69L1064.88,69.23L1064.49,80.77L1064.81,92.31L1065.89,103.85L1067.74,115.38L1070.38,126.92L1073.83,138.46L1078.14,150L1083.29,161.54L1089.39,173.08L1096.4,184.62L1108.33,201.08L1113.69,207.69L1124.07,219.23L1135.77,230.77L1155,247.28L1166.67,256.23L1190,272.39L1260,315.78L1283.33,331.26L1306.67,348.77L1318.33,358.64L1330,369.53L1341.67,381.71L1353.33,395.54L1365,411.48L1374.73,426.92L1381.04,438.46L1386.62,450L1391.49,461.54L1395.69,473.08L1400,487.83M1098.15,0L1091.61,23.08L1088.94,34.62L1085.14,57.69L1084.14,69.23L1083.81,80.77L1084.2,92.31L1085.34,103.85L1087.3,115.38L1090.08,126.92L1093.71,138.46L1098.24,150L1103.75,161.54L1108.33,169.77L1117.83,184.62L1131.67,202.11L1143.33,214.61L1160.91,230.77L1175.34,242.31L1191.34,253.85L1208.82,265.38L1265.37,300L1283.47,311.54L1306.67,327.72L1318.33,336.74L1330,346.56L1342,357.69L1353.18,369.23L1363.22,380.77L1372.25,392.31L1380.39,403.85L1387.71,415.38L1394.31,426.92L1400,438.05M1116.28,0L1110.26,23.08L1105.81,46.15L1104.36,57.69L1103.52,69.23L1103.35,80.77L1103.89,92.31L1105.21,103.85L1107.34,115.38L1110.36,126.92L1114.33,138.46L1120,151.55L1125.24,161.54L1132.3,173.08L1140.66,184.62L1155,201.13L1161.46,207.69L1174.13,219.23L1188.43,230.77L1204.44,242.31L1221.95,253.85L1271.67,284.07L1296.87,300L1318.33,314.94L1330,323.92L1341.67,333.68L1355.11,346.15L1366.25,357.69L1376.29,369.23L1388.33,384.84L1400,402.16M1134.46,0L1129.04,23.08L1125.13,46.15L1123.92,57.69L1123.31,69.23L1123.37,80.77L1124.17,92.31L1125.78,103.85L1128.24,115.38L1131.6,126.92L1136.05,138.46L1143.33,153.25L1148.21,161.54L1156.11,173.08L1165.45,184.62L1176.34,196.15L1188.85,207.69L1203.14,219.23L1219.21,230.77L1236.79,242.31L1306.67,284.98L1328.54,300L1341.67,309.97L1357.17,323.08L1365,330.34L1376.67,342.15L1390.28,357.69L1400,370.18M1152.91,0L1148.22,23.08L1144.96,46.15L1144.08,57.69L1143.8,69.23L1144.21,80.77L1145.4,92.31L1147.43,103.85L1150.38,115.38L1154.3,126.92L1159.41,138.46L1165.65,150L1173.33,161.54L1182.42,173.08L1193.13,184.62L1205.62,196.15L1213.33,202.5L1236.67,219.59L1254.07,230.77L1311.42,265.38L1330,277.46L1341.67,285.64L1360.14,300L1373.32,311.54L1388.33,326.37L1400,339.41M1171.92,0L1168.07,23.08L1165.69,46.15L1165.26,57.69L1165.45,69.23L1166.33,80.77L1168.06,92.31L1170.72,103.85L1174.36,115.38L1179.08,126.92L1185.16,138.46L1192.57,150L1201.51,161.54L1212.26,173.08L1224.87,184.62L1236.67,193.98L1260,210.16L1274.49,219.23L1318.33,245.29L1349.4,265.38L1365.08,276.92L1376.67,286.31L1388.33,296.73L1400,308.3M1191.72,0L1188.97,23.08L1187.76,46.15L1187.93,57.69L1188.76,69.23L1190.35,80.77L1192.89,92.31L1196.43,103.85L1201.02,115.38L1207.07,126.92L1214.47,138.46L1223.62,150L1234.67,161.54L1247.74,173.08L1260,182.4L1283.33,197.94L1330,225.49L1356.95,242.31L1376.67,256.19L1388.26,265.38L1400,275.61M1212.73,0L1211.43,23.08L1211.35,34.62L1211.77,46.15L1212.79,57.69L1214.59,69.23L1217.29,80.77L1220.97,92.31L1225,102.1L1232.14,115.38L1240.01,126.92L1249.72,138.46L1260,148.56L1271.67,158.32L1283.33,166.89L1306.67,181.89L1365,215.8L1387.61,230.77L1400,240.02M1235.53,0L1236.14,23.08L1237.13,34.62L1238.78,46.15L1241.16,57.69L1244.41,69.23L1248.66,80.77L1254.4,92.31L1261.54,103.85L1270.6,115.38L1281.88,126.92L1295,137.95L1312.38,150L1331.54,161.54L1376.67,186.25L1400,200.2M1260.96,0L1264.49,23.08L1267.16,34.62L1271.67,49.09L1275.21,57.69L1283.33,73.12L1288.51,80.77L1297.92,92.31L1309.86,103.85L1318.33,110.68L1330,118.85L1341.67,126.02L1353.33,132.39L1400,155.35M1290.66,0L1294.19,11.54L1298.79,23.08L1306.67,38.58L1311.64,46.15L1318.33,55.02L1330,67.16L1341.67,76.67L1347.64,80.77L1365,91.07L1376.67,96.78L1400,106.6M1327.78,0L1335.63,11.54L1341.67,19.03L1353.33,30.48L1365,39.39L1376.67,46.53L1388.33,52.39L1400,57.29M1382.96,0L1388.33,3.53L1400,9.8M0,308.3L11.67,321.18L22.59,334.62L39.1,357.69L53.43,380.77L59.96,392.31L77.75,426.92L88.36,450L98.12,473.08L108.06,499.18L113.94,516.53L118.7,532.78L122.36,547.94L124.52,561.62L125.29,573.91L124.27,588.46L123.07,594.79L120.28,603.58L112.51,618.97L107.76,625.81L100.69,634.62L85.76,650.2L64.36,669.23L41.91,687.61L0,720.79M0,339.41L11.67,354.01L22.54,369.23L37.03,392.31L49.6,415.38L55.27,426.92L65.54,450L74.42,473.08L78.31,484.62L84.91,507.69L87.54,519.23L89.58,530.77L90.98,542.31L91.63,553.85L91.44,565.38L90.63,574.25L87.95,588.46L84.27,600L80.02,609.91L72.83,623.08L62.16,638.4L51.63,651.06L45.48,657.69L28.76,674.59L0,700.77M0,370.18L15.08,392.31L28.38,415.38L39.63,438.46L49.04,461.54L56.67,484.62L62.41,507.69L64.46,519.23L65.88,530.77L66.62,542.31L66.66,550.54L65.74,565.38L62.92,581.46L60.42,590.53L57.08,600L50.22,615.06L41.64,629.64L29.74,646.15L16.21,662.18L0,679.26M0,402.16L7.87,415.38L19.64,438.46L29.22,461.54L33.2,473.08L39.6,496.15L41.94,507.69L43.66,519.23L44.54,528.67L45.08,542.31L44.68,553.85L43.45,565.38L42.2,572.51L38.19,588.46L34.02,600L28.9,611.54L18.5,629.83L7.15,646.15L0,655.1M0,438.05L5.49,450L10.13,461.54L14.19,473.08L17.65,484.62L20.48,496.15L22.68,507.69L24.24,519.23L25.12,530.77L25.26,542.31L24.6,553.85L23.1,565.38L20.76,576.92L17.49,588.46L13.21,600L9.16,609.06L0,625.9M0,487.83L4.26,507.69L5.74,519.23L6.51,537.2L6.09,548.33L5.01,558.8L3.35,568.7L0,582M1400,582L1398.1,588.46L1393.77,600L1388.41,611.62L1380.18,626.55L1367.21,646.15L1356.2,660.53L1339.14,680.77L1279,745.71L1262.66,764.17L1246.9,783.2L1231.9,802.98L1222.43,816.69L1209.09,838.11L1200.43,853.85L1193.11,868.46L1185.9,884.4L1179.21,900.87L1172.96,917.76L1161.63,952.71L1138.47,1033.65L1124.75,1077.78L1112.75,1112.06L1088.02,1176.92L1079.81,1200M1400,625.9L1394.63,634.62L1386.54,646.15L1368.06,669.23L1347.2,692.31L1287.82,754.44L1271.45,772.86L1260.88,785.49L1245.69,805.08L1231.46,825.62L1221.16,842.31L1210.2,862.29L1202.63,877.88L1195.58,893.98L1188.7,911.54L1180.65,934.62L1170.13,969.23L1149.45,1044.51L1138.91,1080.24L1127.55,1115.16L1105.77,1176.92L1098.15,1200M1400,655.1L1393.59,662.89L1377.46,680.77L1306.67,752.44L1291.06,769.18L1274.86,787.77L1259.45,807.15L1245,827.48L1231.66,848.89L1222.6,865.38L1212.08,887.22L1205.21,903.5L1197.83,923.08L1190.18,946.15L1180.15,980.77L1160.54,1055.48L1150.39,1091.6L1116.28,1200M1400,679.26L1381.76,697.34L1341.67,735.35L1322.52,754.14L1305.39,771.81L1288.92,790.14L1273.25,809.26L1258.56,829.35L1244.99,850.54L1232.64,872.94L1225.13,888.46L1215.4,911.54L1207.06,934.62L1199.81,957.69L1190.31,992.31L1171.86,1066.68L1162.2,1103.27L1134.46,1200M1400,700.77L1365,731.81L1341.67,753.26L1318.33,776.29L1297.71,798.83L1282.06,817.97L1267.48,838.16L1254.06,859.51L1241.92,882.11L1233.6,900L1224.53,922.62L1216.49,946.15L1209.66,969.23L1200.74,1003.85L1183.56,1078.25L1174.49,1115.43L1158.5,1176.92L1152.91,1200M1400,720.79L1364.98,749.98L1341.67,771.11L1323.23,789.46L1306.51,807.69L1290.98,826.79L1276.49,847.07L1263.23,868.58L1251.3,891.4L1242.34,911.54L1233.62,934.62L1226.22,957.69L1219.86,980.77L1211.59,1015.38L1195.82,1090.37L1176.6,1176.92L1171.92,1200M0,739.96L23.33,723.07L58.33,699.83L81.67,685.68L93.33,679.17L105,673.02L116.67,667.61L124.08,665.02L128.33,662.99L132.85,662.16L140,659.95L151.67,659.05L163.33,661.18L175,667.7L186.67,678.51L198.33,693.14L210,709.93L257.33,784.62L281.15,819.23L298.61,842.31L308,853.85L328.4,876.92L351.56,900L364.42,911.54L385,928.46L396.67,937.32L420,953.89L478.33,992.84L493.78,1003.85L508.72,1015.38L522.18,1026.92L534.06,1038.46L544.35,1050L553.16,1061.54L560.6,1073.08L566.62,1084.62L571.48,1096.15L575.05,1107.69L577.51,1119.23L578.87,1130.77L579.15,1142.31L578.37,1153.85L576.55,1165.38L573.73,1176.92L571.67,1183.18L565.05,1200M1400,739.96L1376.67,758.19L1353.33,778.27L1332.36,798.49L1315.66,816.58L1300.05,835.77L1285.63,856.12L1273.01,876.92L1261.23,900L1251.44,923.08L1243.27,946.15L1236.37,969.23L1230.53,992.31L1225.38,1015.38L1218.57,1050L1197.39,1165.38L1191.72,1200M0,758.66L23.33,742.97L46.67,729.16L58.33,722.97L81.67,712.32L93.33,708.03L105,704.69L116.67,702.37L128.33,701.38L140,702.09L151.67,704.78L163.33,709.6L175,716.99L186.67,726.75L198.33,738.58L210,752.05L221.67,766.77L269.39,830.77L287.62,853.85L303.33,872.38L315,885.3L338.33,908.92L361.67,929.8L385,948.39L408.33,965.34L464.66,1003.85L490,1022.9L507.97,1038.46L519.38,1050L529.18,1061.54L537.49,1073.08L544.24,1084.62L549.68,1096.15L553.74,1107.69L556.59,1119.23L558.24,1130.77L558.72,1142.31L558.04,1153.85L556.25,1165.38L553.39,1176.92L549.52,1188.46L544.57,1200M1400,758.66L1376.67,776.38L1353.33,796.54L1336.04,813.67L1320.61,830.77L1306.67,848.48L1294.97,865.38L1281.45,888.46L1270.25,911.54L1261.02,934.62L1253.45,957.69L1247.12,980.77L1239.49,1015.38L1233.29,1050L1224.45,1107.69L1216.5,1165.38L1212.73,1200M0,777.31L23.33,762.38L35,755.83L58.33,744.62L70,740.07L81.67,736.29L93.33,733.39L105,731.53L116.67,730.86L128.33,731.55L140,733.8L151.67,737.84L163.33,743.61L175,751.37L186.67,760.9L198.33,772.03L210,784.54L221.67,798.01L266.84,853.85L286.21,876.92L307.02,900L329.99,923.08L350,941.21L373.33,960.26L396.67,977.67L450.16,1015.38L465.5,1026.92L478.33,1037.43L492.08,1050L502.99,1061.54L512.25,1073.08L519.86,1084.62L526.04,1096.15L530.67,1107.69L533.99,1119.23L536,1130.77L536.67,1143.57L536.19,1153.85L534.44,1165.38L531.54,1176.92L527.56,1188.46L522.48,1200M1400,777.31L1388.33,785.72L1376.67,794.84L1361.75,807.69L1353.33,815.53L1341.67,827.36L1330,840.44L1323.99,847.9L1311.02,865.38L1303.47,876.92L1296.64,888.46L1284.9,911.54L1275.37,934.62L1267.62,957.69L1261.31,980.77L1256.22,1003.85L1250.17,1038.46L1244.16,1084.62L1239.49,1130.77L1236.79,1165.38L1235.53,1200M0,796.21L11.67,788.59L23.33,781.71L35,775.56L46.67,770.16L58.33,765.54L70,761.75L81.67,758.83L93.33,756.91L105,756.09L116.67,756.49L128.33,758.24L140,761.5L151.67,766.26L163.33,772.72L175,780.72L186.67,790.28L198.33,801.21L210,813.27L221.67,826.21L264.65,876.92L284.78,900L303.33,919.99L326.67,943.03L338.33,953.67L361.67,973.34L385,991.31L433.52,1026.92L448.25,1038.46L466.67,1054.62L473.77,1061.54L484.11,1073.08L492.78,1084.62L499.78,1096.15L501.67,1100.05L505.15,1107.69L509,1119.23L511.43,1130.77L512.45,1142.31L512.08,1153.85L510.39,1165.38L507.44,1176.92L503.34,1188.46L497.99,1200M1400,796.21L1384.48,807.69L1365,824.23L1347.08,842.31L1337.07,853.85L1330,862.76L1318.33,879.37L1306.09,900L1294.96,923.04L1286.09,946.15L1279.03,969.23L1271.67,1001.07L1267.33,1026.92L1263.18,1061.54L1260,1104.55L1258.79,1142.31L1259.27,1176.92L1260.96,1200M0,815.8L11.67,808.1L23.33,801.35L35,795.43L46.67,790.41L58.33,786.24L70,783.01L81.67,780.76L93.33,779.57L105,779.53L116.67,780.72L128.33,783.27L140,787.22L151.67,792.65L157.61,796.15L163.33,799.58L175,807.97L186.67,817.71L198.33,828.66L210,840.62L232.25,865.38L280,920.24L293.3,934.62L315,956.63L326.67,967.67L350,988.2L373.33,1007.06L413.86,1038.46L427.89,1050L440.77,1061.54L452.15,1073.08L461.84,1084.62L469.82,1096.15L476.06,1107.69L478.33,1113.29L480.6,1119.23L483.47,1130.77L484.8,1142.31L484.62,1153.85L482.98,1165.38L479.98,1176.92L475.54,1188.46L469.8,1200M1400,815.8L1388.33,824.45L1380.65,830.77L1365,845.07L1353.33,857.47L1346.65,865.38L1337.76,876.92L1330,888.14L1318.33,908.1L1310.99,923.08L1306.01,934.62L1301.7,946.15L1294.45,969.23L1289.03,992.31L1286.84,1003.85L1283.38,1026.92L1281.13,1050L1279.48,1084.62L1279.76,1119.23L1282.16,1153.85L1285.43,1176.92L1290.66,1200M0,836.54L11.67,828.59L23.33,821.74L35,815.92L46.67,811.09L58.33,807.23L70,804.44L81.67,802.7L93.33,802.09L105,802.67L116.67,804.52L128.36,807.72L140,812.31L153.12,819.23L163.33,825.76L175,834.57L186.67,844.64L198.33,855.83L210,867.95L221.67,880.78L280,947.71L303.33,972.57L315,984.21L338.33,1005.95L402.94,1061.54L414.91,1073.08L420,1078.59L425.47,1084.62L434.4,1096.15L441.53,1107.69L446.78,1119.23L450.22,1130.77L451.92,1142.31L451.86,1153.85L450.08,1165.38L446.69,1176.92L443.33,1184.9L441.72,1188.46L435.06,1200M1400,836.54L1388.33,845.64L1379.07,853.85L1367.55,865.38L1353.33,882.22L1340.92,900L1334.18,911.54L1328.16,923.08L1318.3,946.15L1310.98,969.23L1305.55,992.31L1301.93,1015.38L1299.73,1038.46L1299.14,1050L1298.91,1073.08L1299.96,1096.15L1300.98,1107.69L1304.1,1130.77L1306.26,1142.31L1309.05,1153.85L1312.45,1165.38L1318.33,1181.51L1327.78,1200M0,859.19L11.67,850.68L23.33,843.48L35,837.58L46.67,832.76L58.33,829.1L70,826.61L81.67,825.27L93.33,825.14L105,826.26L116.67,828.69L128.33,832.51L140,837.74L151.67,844.37L163.33,852.39L175,861.78L191.26,876.92L210,896.67L232.85,923.08L268.33,965.63L303.33,1005.01L326.67,1029.13L370.97,1073.08L381.37,1084.62L390.52,1096.15L398.15,1107.69L403.84,1119.23L407.7,1130.77L409.42,1142.31L409.08,1153.85L406.56,1165.38L401.84,1176.92L395.02,1188.46L385.73,1200M1400,859.19L1388.33,869.18L1380.5,876.92L1370.24,888.46L1365,895.06L1353.33,912.12L1341.67,934.05L1336.6,946.15L1332.39,957.69L1328.83,969.23L1325.95,980.77L1321.69,1003.85L1319.33,1026.92L1318.83,1038.46L1319.17,1061.54L1321.33,1084.62L1325.44,1107.69L1328.3,1119.23L1331.92,1130.77L1336.43,1142.31L1341.67,1153.64L1348.7,1165.38L1353.33,1172.16L1365,1185.53L1376.67,1195.64L1382.96,1200M0,885.13L11.67,875.46L23.33,867.6L35,861.27L46.67,856.28L58.33,852.62L70,850.31L81.67,849.27L93.33,849.55L105,851.17L116.67,854.18L128.33,858.71L140,864.6L151.67,872.05L163.33,880.9L175,891.11L186.67,902.63L205.06,923.08L232.87,957.69L300.05,1046.76L319.32,1073.08L327.11,1084.62L333.95,1096.15L340.38,1109.72L343.47,1119.23L345.24,1130.77L344.36,1142.31L343.01,1146.94L339.61,1155.11L334.86,1161.95L331.94,1165.38L326.67,1170.2L317.44,1176.92L303.33,1183.79L291.24,1188.04L272.11,1192.2L251.31,1194.7L217.67,1196.05L170.45,1195.5L121.7,1193.44L105,1192.21L81.67,1189.72L58.33,1185.83L46.67,1183.13L35,1179.74L23.33,1175.49L11.67,1170.13L0,1163.35M1400,885.13L1388.33,896.86L1376.44,911.54L1365,929.9L1357.1,946.15L1352.51,957.69L1348.88,969.23L1345.89,980.77L1343.54,992.31L1341.81,1003.85L1340.76,1015.38L1340.29,1026.92L1341.05,1050L1342.34,1061.54L1344.34,1073.08L1347.02,1084.62L1350.42,1096.15L1354.75,1107.69L1360.32,1119.23L1365,1127.51L1375.93,1142.31L1388.33,1154.63L1400,1163.35M0,917.79L11.67,905.57L18.23,900L23.33,896.05L35,888.57L46.67,883.14L58.33,879.19L70,876.78L81.67,875.96L93.33,876.6L105,878.84L116.67,882.62L128.33,887.86L140,894.89L151.67,903.45L163.33,913.63L172.76,923.08L183.08,934.62L201.17,957.69L209.32,969.23L224.09,992.31L230.87,1003.85L241.47,1023.43L251.25,1044.65L257.52,1062.38L260.07,1073.08L260.86,1077.22L261.57,1089.47L260.18,1099.63L257.06,1108.08L252.66,1115.27L247.1,1121.3L240.66,1126.48L233.51,1130.77L225.62,1134.68L217.25,1137.94L199.15,1143.12L179.74,1146.99L159.11,1149.67L128.33,1151.54L105,1151.33L81.67,1149.35L70,1147.53L58.33,1145.03L46.67,1141.68L35,1137.24L23.33,1131.51L11.67,1123.94L0,1113.91M1400,917.79L1395.8,923.08L1387.76,934.62L1381.5,946.15L1376.2,957.69L1372.23,969.23L1369.09,980.77L1366.77,992.31L1365.27,1003.85L1364.63,1015.38L1365,1029.9L1365.75,1038.46L1367.62,1050L1370.4,1061.54L1374.12,1073.08L1379.14,1084.62L1385.7,1096.15L1394.36,1107.69L1400,1113.91M0,975.32L2.05,969.23L7.25,957.69L11.67,949.84L14.1,946.15L23.25,934.62L35,924.18L46.67,916.98L58.33,911.94L70,909.26L81.67,908.46L93.33,909.48L105,912.36L116.67,917.32L126.82,923.08L140,933.01L151.67,944.27L163.33,958.04L171.13,969.23L178.17,980.77L184.19,992.31L189.21,1003.85L193.17,1015.38L195.47,1024.09L197.53,1038.46L197.29,1050L195.65,1058.88L192.52,1067.33L188.24,1074.63L182.95,1080.94L176.83,1086.43L169.94,1091.15L162.4,1095.23L154.24,1098.7L145.49,1101.58L136.2,1103.94L126.38,1105.76L116.67,1106.96L105,1107.6L93.33,1107.37L81.67,1106.21L70,1104.05L58.33,1100.74L46.67,1096.09L35,1089.34L23.33,1080.01L16.92,1073.08L11.67,1066.31L8.65,1061.54L2.82,1050L0,1042.51M1400,975.32L1398.39,980.77L1396.13,992.31L1395.02,1003.85L1395.06,1015.38L1396.28,1026.92L1398.73,1038.46L1400,1042.51M816.67,67.61L805,73.02L781.67,85.68L746.67,107.33L723.33,123.07L700,139.96L676.67,158.19L665,167.97L653.33,178.27L638.16,192.68L623.62,207.69L613.37,219.23L605.1,229.22L595,242.47L583.33,259.69L572.54,277.78L560,302.73L551.44,323.08L547.16,334.62L543.27,346.15L536.37,369.23L530.53,392.31L525.38,415.38L518.57,450L501.57,542.31L491.72,600L488.97,623.08L488.13,634.62L487.93,657.69L488.76,669.23L490.35,680.77L492.89,692.31L496.43,703.85L501.67,716.7L507.07,726.92L514.47,738.46L523.62,750L534.67,761.54L548.33,773.56L560,782.4L571.67,790.42L595,805.01L641.67,832.56L656.95,842.31L673.49,853.85L688.26,865.38L700,875.61L711.67,886.93L723.68,900L735,913.74L746.67,929.52L758.33,947.05L771.77,969.23L790.76,1003.85L828.33,1077.3L840,1098.69L851.67,1117.78L863.33,1133.39L875,1144.15L886.67,1149.76L898.33,1150.6L904.88,1148.78L910,1147.91L921.67,1142.5L933.33,1135.34L945,1126.53L956.67,1116.32L968.33,1104.74L980,1091.69L991.67,1076.96L1003.33,1060.22L1015,1040.93L1022.37,1026.92L1028.07,1015.38L1038.15,992.31L1050,960.54L1067.85,906.12L1079.85,871.83L1089.84,847.1L1100.99,823.5L1113.36,801.13L1117.81,793.98L1126.94,779.94L1136.58,766.4L1146.64,753.27L1162.28,734.12L1209,680.77L1225,661.63L1237.05,646.15L1245.21,634.62L1252.66,623.08L1259.33,611.54L1265.05,600L1269.88,588.46L1273.73,576.92L1276.55,565.38L1278.37,553.85L1279.15,542.31L1278.87,530.77L1277.51,519.23L1275.05,507.69L1271.48,496.15L1266.62,484.62L1260,472.11L1253.16,461.54L1244.35,450L1234.06,438.46L1225,429.57L1213.33,419.24L1201.67,409.85L1177.57,392.31L1108.33,345.75L1093.08,334.62L1078.24,323.08L1064.42,311.54L1051.56,300L1028.4,276.92L1008,253.85L998.61,242.31L981.15,219.23L964.99,196.15L949.78,173.08L910,109.93L898.33,93.14L886.67,78.51L875,67.7L863.33,61.18L851.67,59.05L840,59.95L832.85,62.16L828.33,62.99L824.08,65.02L816.67,67.61M816.67,102.37L805,104.69L793.33,108.03L781.67,112.32L758.33,122.97L746.67,129.16L723.33,142.97L700,158.66L688.33,167.25L666.78,184.62L653.76,196.15L641.71,207.74L630,220.03L618.33,233.5L604.4,251.6L594.97,265.38L583.33,285.02L575.6,300L570.25,311.54L561.02,334.62L557.06,346.15L553.45,357.69L547.12,380.77L541.85,403.85L537.28,426.92L531.43,461.54L524.45,507.69L518.01,553.85L513.8,588.46L511.92,611.54L511.43,623.08L511.77,646.15L512.79,657.69L514.59,669.23L517.29,680.77L520.97,692.31L525,702.1L532.14,715.38L536.67,722.29L548.33,736.94L561.59,750L571.67,758.32L583.33,766.89L606.67,781.89L653.33,808.81L676.67,823.23L700,840.02L711.67,849.71L723.33,860.57L735,872.8L746.67,886.6L756.84,900L764.92,911.54L772.45,923.08L786.48,946.15L828.33,1020.17L840,1039L851.67,1055.7L863.33,1069.65L875,1080.45L881.49,1084.62L886.67,1087.89L898.33,1092.03L910,1093.1L921.67,1091.42L933.33,1087.26L945,1080.85L956.67,1072.32L968.33,1061.65L980,1048.64L991.67,1033L995.56,1026.92L1003.33,1014.3L1014.68,992.31L1024.6,969.23L1037.35,934.62L1058.01,873.31L1067.69,848.26L1078.51,824.35L1082.45,816.71L1090.63,801.72L1104.03,780.36L1113.6,766.74L1123.63,753.59L1150.05,722.02L1178.33,690.65L1201.67,663.78L1215.79,646.15L1224.23,634.62L1231.85,623.08L1238.69,611.54L1244.57,600L1249.52,588.46L1253.39,576.92L1256.25,565.38L1258.04,553.85L1258.72,542.31L1258.24,530.77L1256.59,519.23L1253.74,507.69L1249.68,496.15L1244.24,484.62L1237.49,473.08L1229.18,461.54L1219.38,450L1207.97,438.46L1194.96,426.92L1178.33,413.81L1164.66,403.85L1108.33,365.34L1085,348.39L1061.67,329.8L1038.33,308.92L1015,285.3L1003.33,272.38L987.62,253.85L969.39,230.77L921.67,166.77L910,152.05L898.33,138.58L886.67,126.75L875,116.99L863.33,109.6L851.67,104.78L840,102.09L828.33,101.38L816.67,102.37M781.67,136.29L770,140.07L758.33,144.62L735,155.83L723.33,162.38L700,177.31L688.33,185.72L676.67,194.84L665,204.74L653.33,215.53L640.02,229.14L629.14,241.46L618.33,255.11L606.67,271.91L600.34,282.2L592.03,297.07L584.9,311.54L579.89,323.08L571.67,344.96L564.31,369.23L560,386.35L556.22,403.85L552.02,426.92L548.33,451.01L544.16,484.62L540.56,519.23L537.59,553.85L536.16,576.92L535.53,600L535.64,611.54L537.13,634.62L538.78,646.15L541.16,657.69L544.41,669.23L548.66,680.77L554.4,692.31L560,701.57L571.67,716.59L583.33,728.25L595,737.95L606.67,746.24L630,760.66L676.67,786.25L700,800.2L711.67,808.11L723.33,816.83L739.42,830.77L746.67,837.9L758.33,850.76L769.89,865.38L778.14,876.92L785.75,888.46L799.75,911.54L828.33,961.87L840,981.18L851.67,998.45L863.33,1013.27L875,1025.18L886.67,1033.98L895.72,1038.46L898.33,1039.7L910,1042.34L921.67,1042.08L934.55,1038.46L945,1033.2L956.67,1024.62L968.33,1013.02L980,997.99L983.62,992.31L991.67,978.96L1003.33,954.88L1015,925.27L1033.31,871.95L1046.31,838.66L1057.4,815.01L1069.91,792.77L1078.97,778.65L1088.62,765.12L1103.93,745.64L1125.52,720.84L1166.67,676.48L1190,649.37L1201.67,634.23L1209.29,623.08L1216.37,611.54L1222.48,600L1227.56,588.46L1231.54,576.92L1234.44,565.38L1236.19,553.85L1236.67,543.57L1236,530.77L1233.99,519.23L1230.67,507.69L1226.04,496.15L1219.86,484.62L1213.33,474.65L1201.67,460.09L1190,448.03L1179.55,438.46L1165.5,426.92L1150.16,415.38L1096.67,377.67L1073.33,360.26L1050,341.21L1029.99,323.08L1015,308.32L991.67,283.15L966.84,253.85L921.67,198.01L910,184.54L898.33,172.03L886.67,160.9L875,151.37L863.33,143.61L851.67,137.84L840,133.8L828.33,131.55L816.67,130.86L805,131.53L793.33,133.39L781.67,136.29M781.67,158.83L770,161.75L758.33,165.54L746.67,170.16L735,175.56L723.33,181.71L711.67,188.59L700.08,196.15L688.33,204.66L676.67,213.97L665,224.23L653.33,235.62L641.67,248.37L630,262.76L619.93,276.92L612.69,288.46L606.09,300L600.27,311.54L594.96,323.04L590.3,334.62L583.33,354.52L579.03,369.23L573.44,392.31L571.12,403.85L565.76,438.46L563.18,461.54L561.23,484.62L559.83,507.69L559,530.77L558.75,553.85L559.27,576.92L560.96,600L562.46,611.54L564.49,623.08L567.16,634.62L570.6,646.15L575.21,657.69L583.33,673.12L588.51,680.77L597.92,692.31L609.86,703.85L618.33,710.68L630,718.85L641.67,726.02L653.33,732.39L700,755.35L723.33,767.55L735,774.46L746.67,782.17L764.48,796.15L776.55,807.69L786.84,819.23L795.75,830.77L803.67,842.31L817.58,865.38L840,906.69L851.67,927.15L863.33,945.21L875,959.94L886.67,971.2L898.33,978.85L910,982.89L921.67,983.35L933.33,980.27L945,973.24L956.67,962.11L968.36,946.18L980.55,923.08L991.67,896.31L1009.45,848.36L1019.98,824.16L1031.9,801.33L1045.33,780L1055.07,766.55L1065.36,753.66L1081.6,735.09L1104.22,711.31L1143.33,671.73L1156.35,657.69L1166.67,645.86L1175.66,634.62L1184.07,623.08L1190,614.07L1197.99,600L1201.67,592.19L1207.44,576.92L1210.39,565.38L1212.08,553.85L1212.45,542.31L1211.43,530.77L1209,519.23L1205.15,507.69L1199.78,496.15L1192.78,484.62L1190,480.79L1184.11,473.08L1173.77,461.54L1161.77,450L1148.25,438.46L1133.52,426.92L1085,391.31L1061.67,373.34L1038.33,353.67L1026.67,343.03L1006.34,323.08L991.67,307.58L968.33,281.21L921.67,226.21L910,213.27L898.33,201.21L886.67,190.28L875,180.72L863.33,172.72L851.67,166.26L840,161.5L828.33,158.24L816.67,156.49L805,156.09L793.33,156.91L781.67,158.83M770,183.01L758.33,186.24L746.67,190.41L735,195.43L723.33,201.35L711.67,208.1L700,215.8L688.33,224.45L676.67,234.15L665,245.07L656.61,253.85L646.65,265.38L637.76,276.92L629.87,288.33L622.82,300L616.52,311.54L610.99,323.08L606.01,334.62L601.7,346.15L595,367.3L591.56,380.77L586.84,403.85L583.38,426.92L582.13,438.46L579.81,473.08L579.36,496.15L579.76,519.23L582.16,553.85L583.55,565.38L587.77,588.46L590.66,600L595,613.82L598.79,623.08L604.43,634.62L611.64,646.15L618.33,655.02L632.39,669.23L641.67,676.67L647.64,680.77L653.33,684.47L667.48,692.31L688.33,701.91L746.67,724.17L770,734.06L779.24,738.46L793.33,746.2L805,753.59L815.95,761.54L828.33,772.28L840.26,784.62L849.8,796.15L858.25,807.69L886.67,851.9L898.33,865.62L910,873.16L921.67,873.99L933.33,867.72L945,854.74L949.66,846.92L956.67,837.1L963.13,825.62L968.33,818.29L972.2,811.51L976.91,804.63L980,800.85L986.56,791.1L991.67,785.14L996.83,778.18L1007.65,765.8L1018.93,753.88L1042.55,731.09L1096.67,683.27L1120,661.5L1131.67,649.72L1143.33,636.97L1154.71,623.08L1162.79,611.54L1169.8,600L1175.54,588.46L1179.98,576.92L1182.98,565.38L1184.62,553.85L1184.8,542.31L1183.47,530.77L1180.6,519.23L1178.33,513.29L1176.06,507.69L1169.82,496.15L1161.84,484.62L1152.15,473.08L1140.77,461.54L1127.89,450L1113.86,438.46L1073.33,407.06L1050,388.2L1026.67,367.67L1015,356.63L993.3,334.62L980,320.24L932.25,265.38L910,240.62L898.33,228.66L886.67,217.71L875,207.97L863.33,199.58L857.61,196.15L851.67,192.65L840,187.22L828.33,183.27L816.67,180.72L805,179.53L793.33,179.57L781.67,180.76L770,183.01M758.33,207.23L746.67,211.09L735,215.92L723.33,221.74L711.67,228.59L700,236.54L692.5,242.31L676.67,256.08L665,268.14L657.53,276.92L648.73,288.46L641.67,298.83L634.18,311.54L628.16,323.08L618.3,346.15L614.4,357.69L608.02,380.77L603.55,403.85L601.93,415.38L599.73,438.46L599.14,450L598.91,473.08L599.96,496.15L600.98,507.69L604.1,530.77L606.26,542.31L609.05,553.85L612.45,565.38L616.5,576.92L621.57,588.46L630,603.67L635.63,611.54L641.67,619.03L645.56,623.08L653.33,630.48L665,639.39L676.67,646.53L688.33,652.39L700,657.29L723.33,665.18L749.68,672.22L793.33,682.61L828.33,691.9L898.33,714.57L910,717.69L921.67,719.98L933.33,721.16L945,721.13L956.67,719.85L968.33,717.38L980,713.9L991.67,709.57L1015,698.71L1038.33,685.59L1050,678.28L1073.33,662.08L1085,653.04L1096.67,643.22L1105.99,634.62L1117.19,623.08L1126.86,611.54L1135.06,600L1141.72,588.46L1146.69,576.92L1150.08,565.38L1151.86,553.85L1151.92,542.31L1150.22,530.77L1146.78,519.23L1141.53,507.69L1134.4,496.15L1131.67,492.54L1125.47,484.62L1114.91,473.08L1102.94,461.54L1089.95,450L1038.33,405.95L1015,384.21L1003.33,372.57L980,347.71L921.67,280.78L910,267.95L898.33,255.83L886.67,244.64L875,234.57L863.33,225.76L851.67,218.32L840,212.31L828.36,207.72L816.67,204.52L805,202.67L793.33,202.09L781.67,202.7L770,204.44L758.33,207.23M758.33,229.1L746.67,232.76L735,237.58L723.33,243.48L711.67,250.68L700,259.19L692.61,265.38L676.67,280.98L670.24,288.46L661.4,300L653.68,311.54L647.19,323.08L641.4,334.62L636.6,346.15L632.39,357.69L628.83,369.23L623.58,392.31L621.69,403.85L619.33,426.92L618.83,438.46L619.17,461.54L621.33,484.62L625.44,507.69L628.3,519.23L631.92,530.77L636.43,542.31L641.78,553.85L648.7,565.38L653.33,572.16L657.22,576.92L665,585.53L668.2,588.46L676.67,595.64L688.33,603.53L700,609.8L711.67,614.86L723.33,619.01L735,622.41L758.33,627.77L781.67,631.79L900.77,648.56L933.33,652.31L956.67,653.25L968.33,652.88L980,651.82L991.67,650.02L1003.33,647.44L1015,644L1026.67,639.67L1038.33,634.49L1050,628.13L1058.09,623.08L1073.33,611.84L1085.73,600L1096.67,585.91L1101.84,576.92L1106.56,565.38L1109.08,553.85L1109.42,542.31L1108.33,534.84L1107.7,530.77L1103.84,519.23L1096.67,505.41L1090.52,496.15L1081.37,484.62L1070.97,473.08L1059.7,461.54L1015,417.28L991.71,392.31L968.33,365.63L921.67,309.93L902.45,288.46L886.67,272.39L875,261.78L865.19,253.85L851.67,244.37L840,237.74L828.33,232.51L816.67,228.69L805,226.26L793.33,225.14L781.67,225.27L770,226.61L758.33,229.1M758.33,252.62L746.67,256.28L735,261.27L723.33,267.6L709.8,276.92L700,285.13L688.33,296.86L676.44,311.54L665,329.9L657.1,346.15L652.51,357.69L648.88,369.23L645.89,380.77L643.54,392.31L641.81,403.85L640.76,415.38L640.29,426.92L640.39,438.46L641.05,450L642.34,461.54L644.34,473.08L647.02,484.62L650.42,496.15L653.33,504.28L660.32,519.23L665,527.51L675.93,542.31L688.33,554.63L700,563.35L711.67,570.13L723.33,575.49L735,579.74L746.67,583.13L758.33,585.83L781.67,589.72L809.13,592.55L858.42,595.14L906.04,596.08L940.36,595.41L961.91,593.64L981.9,590.34L991.24,588.04L999.97,585.13L1008.18,581.71L1015.93,577.84L1026.67,570.2L1031.94,565.38L1034.86,561.95L1040.32,553.85L1044.36,542.31L1044.99,537.35L1045.24,530.77L1043.47,519.23L1039.61,507.69L1033.95,496.15L1027.11,484.62L1019.32,473.08L1000.05,446.76L932.87,357.69L905.06,323.08L894.96,311.54L884.09,300L875,291.11L863.33,280.9L851.67,272.05L841.28,265.38L828.33,258.71L815.44,253.85L805,251.17L793.33,249.55L781.67,249.27L770,250.31L758.33,252.62M770,276.78L758.33,279.19L746.67,283.14L735.21,288.46L723.33,296.05L711.67,305.57L700,317.79L688.33,333.7L681.5,346.15L676.2,357.69L672.23,369.23L669.09,380.77L666.77,392.31L665.27,403.85L664.63,415.38L665,429.9L665.75,438.46L667.62,450L670.4,461.54L674.12,473.08L679.14,484.62L688.33,500.12L694.36,507.69L700,513.91L705.9,519.23L711.67,523.94L723.33,531.51L735,537.24L746.67,541.68L758.33,545.03L770,547.53L789.66,550.21L814.4,551.6L837.37,551.25L859.11,549.67L879.74,546.99L899.15,543.12L917.25,537.94L925.62,534.68L933.4,530.83L940.66,526.48L947.1,521.3L952.66,515.27L957.06,508.08L960.18,499.63L961.57,489.47L960.86,477.22L960.07,473.08L957.52,462.38L953.29,450L948.54,438.46L941.47,423.43L927.67,398.24L909.32,369.23L892.47,346.15L875,325.47L861.06,311.54L851.67,303.45L840,294.89L828.33,287.86L816.67,282.62L805,278.84L793.33,276.6L781.67,275.96L770,276.78M770,309.26L758.33,311.94L746.67,316.98L735,324.18L723.33,334.52L714.1,346.15L707.25,357.69L702.05,369.23L698.39,380.77L696.13,392.31L695.02,403.85L695.06,415.38L696.28,426.92L698.73,438.46L702.82,450L708.65,461.54L711.67,466.31L716.92,473.08L723.33,480.01L728.71,484.62L735,489.34L746.67,496.09L758.33,500.74L770,504.05L781.67,506.21L793.33,507.37L805,507.6L816.67,506.96L828.33,505.44L840,503L854.24,498.7L862.4,495.23L869.94,491.15L876.83,486.43L882.95,480.94L889.23,473.08L892.52,467.33L895.65,458.88L897.41,449.08L897.49,437.63L896.03,426.92L893.17,415.38L890.72,407.85L884.19,392.31L875,375.48L863.07,357.69L853.41,346.15L841.81,334.62L828.33,324.03L816.67,317.32L805,312.36L801.95,311.54L793.33,309.48L781.67,308.46L770,309.26M758.33,367.98L756.98,369.23L748.3,380.77L744.34,392.31L743.52,403.85L745.41,415.38L746.67,418.58L751.24,426.92L758.33,435.19L762.62,438.46L770,442.72L781.67,446.35L793.33,447.09L800.79,445.84L805,444.88L809.58,442.99L817.19,438.98L822.8,432.99L827.1,426.92L830.27,415.38L829.83,403.85L826.3,392.31L819.63,380.77L816.67,377.12L808.4,369.23L805,366.74L793.33,361.3L783.69,359.7L781.67,359.4L770,361.55L758.33,367.98M58.33,967.98L56.98,969.23L48.3,980.77L44.34,992.31L43.52,1003.85L45.41,1015.38L46.67,1018.58L51.24,1026.92L58.33,1035.19L62.62,1038.46L70,1042.72L81.67,1046.35L93.33,1047.09L100.79,1045.84L105,1044.88L109.58,1042.99L117.19,1038.98L122.8,1032.99L127.1,1026.92L130.27,1015.38L129.83,1003.85L126.3,992.31L119.63,980.77L116.67,977.12L108.4,969.23L105,966.74L93.33,961.3L83.69,959.7L81.67,959.4L70,961.55L58.33,967.98",
    "tracks": [
        {
            "points": [
                [
                    668.450761,
                    611.154981
                ],
                [
                    666.61002,
                    613.523879
                ],
                [
                    664.755003,
                    615.881613
                ],
                [
                    662.885527,
                    618.2279
                ],
                [
                    661.00143,
                    620.562461
                ],
                [
                    659.102567,
                    622.885028
                ],
                [
                    657.188812,
                    625.195341
                ],
                [
                    655.260066,
                    627.493152
                ],
                [
                    653.316247,
                    629.778227
                ],
                [
                    651.357304,
                    632.05035
                ],
                [
                    649.383206,
                    634.309318
                ],
                [
                    647.393952,
                    636.554951
                ],
                [
                    645.389567,
                    638.787089
                ],
                [
                    643.370104,
                    641.005595
                ],
                [
                    641.335644,
                    643.210357
                ],
                [
                    639.286298,
                    645.401288
                ],
                [
                    637.222203,
                    647.57833
                ],
                [
                    635.143526,
                    649.741454
                ],
                [
                    633.050463,
                    651.890659
                ],
                [
                    630.943233,
                    654.025978
                ],
                [
                    628.822086,
                    656.147471
                ],
                [
                    626.687295,
                    658.255235
                ],
                [
                    624.539157,
                    660.349394
                ],
                [
                    622.377995,
                    662.43011
                ],
                [
                    620.204149,
                    664.497571
                ],
                [
                    618.017983,
                    666.552
                ],
                [
                    615.819878,
                    668.593649
                ],
                [
                    613.610231,
                    670.622802
                ],
                [
                    611.389455,
                    672.639769
                ],
                [
                    609.157977,
                    674.644888
                ],
                [
                    606.916234,
                    676.638525
                ],
                [
                    604.664674,
                    678.621069
                ],
                [
                    602.403754,
                    680.592931
                ],
                [
                    600.133936,
                    682.554544
                ],
                [
                    597.855687,
                    684.506359
                ],
                [
                    595.56948,
                    686.448846
                ],
                [
                    593.275787,
                    688.382489
                ],
                [
                    590.975084,
                    690.307785
                ],
                [
                    588.667844,
                    692.225243
                ],
                [
                    586.354541,
                    694.135381
                ],
                [
                    584.035644,
                    696.038724
                ],
                [
                    581.711619,
                    697.935804
                ],
                [
                    579.38293,
                    699.827155
                ],
                [
                    577.050034,
                    701.713313
                ],
                [
                    574.713381,
                    703.594816
                ],
                [
                    572.373416,
                    705.472199
                ],
                [
                    570.030578,
                    707.345995
                ],
                [
                    567.685297,
                    709.216731
                ],
                [
                    565.337995,
                    711.084931
                ],
                [
                    562.989085,
                    712.95111
                ],
                [
                    560.638974,
                    714.815775
                ],
                [
                    558.288057,
                    716.679425
                ],
                [
                    555.936721,
                    718.542547
                ],
                [
                    553.585345,
                    720.405616
                ],
                [
                    551.234296,
                    722.269099
                ],
                [
                    548.883931,
                    724.133445
                ],
                [
                    546.5346,
                    725.999093
                ],
                [
                    544.18664,
                    727.866466
                ],
                [
                    541.840378,
                    729.735973
                ],
                [
                    539.496132,
                    731.608007
                ],
                [
                    537.154209,
                    733.482946
                ],
                [
                    534.814905,
                    735.361152
                ],
                [
                    532.478506,
                    737.24297
                ],
                [
                    530.145287,
                    739.128729
                ],
                [
                    527.815512,
                    741.018742
                ],
                [
                    525.489434,
                    742.913304
                ],
                [
                    523.167298,
                    744.812693
                ],
                [
                    520.849333,
                    746.717172
                ],
                [
                    518.535761,
                    748.626985
                ],
                [
                    516.226793,
                    750.542362
                ],
                [
                    513.922627,
                    752.463512
                ],
                [
                    511.623452,
                    754.390633
                ],
                [
                    509.329445,
                    756.323902
                ],
                [
                    507.040773,
                    758.263485
                ],
                [
                    504.757591,
                    760.209527
                ],
                [
                    502.480044,
                    762.162161
                ],
                [
                    500.208266,
                    764.121504
                ],
                [
                    497.942382,
                    766.08766
                ],
                [
                    495.682504,
                    768.060716
                ],
                [
                    493.428734,
                    770.040747
                ],
                [
                    491.181166,
                    772.027814
                ],
                [
                    488.93988,
                    774.021965
                ],
                [
                    486.704949,
                    776.023236
                ],
                [
                    484.476435,
                    778.031649
                ],
                [
                    482.25439,
                    780.047217
                ],
                [
                    480.038856,
                    782.069941
                ],
                [
                    477.829868,
                    784.09981
                ],
                [
                    475.627448,
                    786.136805
                ],
                [
                    473.431612,
                    788.180895
                ],
                [
                    471.242366,
                    790.232042
                ],
                [
                    469.059707,
                    792.290196
                ],
                [
                    466.883625,
                    794.355303
                ],
                [
                    464.7141,
                    796.427298
                ],
                [
                    462.551106,
                    798.506109
                ],
                [
                    460.394608,
                    800.591659
                ],
                [
                    458.244564,
                    802.683861
                ],
                [
                    456.100924,
                    804.782625
                ],
                [
                    453.963633,
                    806.887853
                ],
                [
                    451.832628,
                    808.999444
                ],
                [
                    449.707838,
                    811.11729
                ],
                [
                    447.58919,
                    813.241278
                ],
                [
                    445.4766,
                    815.371293
                ],
                [
                    443.369981,
                    817.507214
                ],
                [
                    441.269241,
                    819.648917
                ],
                [
                    439.174281,
                    821.796274
                ],
                [
                    437.084998,
                    823.949155
                ],
                [
                    435.001283,
                    826.107426
                ],
                [
                    432.923024,
                    828.270951
                ],
                [
                    430.850103,
                    830.43959
                ],
                [
                    428.782398,
                    832.613204
                ],
                [
                    426.719783,
                    834.791648
                ],
                [
                    424.662128,
                    836.974778
                ],
                [
                    422.6093,
                    839.162447
                ],
                [
                    420.561161,
                    841.354507
                ],
                [
                    418.517569,
                    843.550807
                ],
                [
                    416.478382,
                    845.751196
                ],
                [
                    414.44345,
                    847.955522
                ],
                [
                    412.412623,
                    850.163631
                ],
                [
                    410.385747,
                    852.375366
                ],
                [
                    408.362666,
                    854.590573
                ],
                [
                    406.343219,
                    856.809094
                ],
                [
                    404.327244,
                    859.03077
                ],
                [
                    402.314574,
                    861.255441
                ],
                [
                    400.305043,
                    863.482948
                ],
                [
                    398.298479,
                    865.713127
                ],
                [
                    396.294708,
                    867.945816
                ],
                [
                    394.293554,
                    870.180852
                ],
                [
                    392.294838,
                    872.418068
                ],
                [
                    390.298379,
                    874.657297
                ],
                [
                    388.303991,
                    876.898372
                ],
                [
                    386.311487,
                    879.141122
                ],
                [
                    384.320678,
                    881.385377
                ],
                [
                    382.331371,
                    883.630964
                ],
                [
                    380.34337,
                    885.877706
                ],
                [
                    378.356476,
                    888.125427
                ],
                [
                    376.370487,
                    890.373949
                ],
                [
                    374.385199,
                    892.623089
                ],
                [
                    372.400402,
                    894.872663
                ],
                [
                    370.415886,
                    897.122484
                ],
                [
                    368.431435,
                    899.372362
                ],
                [
                    366.446829,
                    901.622105
                ],
                [
                    364.461847,
                    903.871515
                ],
                [
                    362.476261,
                    906.120391
                ],
                [
                    360.48984,
                    908.368531
                ],
                [
                    358.502348,
                    910.615724
                ],
                [
                    356.513546,
                    912.861757
                ],
                [
                    354.523188,
                    915.106412
                ],
                [
                    352.531024,
                    917.349465
                ],
                [
                    350.536799,
                    919.590685
                ],
                [
                    348.540252,
                    921.829836
                ],
                [
                    346.541116,
                    924.066677
                ],
                [
                    344.539118,
                    926.300956
                ],
                [
                    342.533978,
                    928.532416
                ],
                [
                    340.525409,
                    930.76079
                ],
                [
                    338.513119,
                    932.985804
                ],
                [
                    336.496805,
                    935.207173
                ],
                [
                    334.476159,
                    937.424602
                ],
                [
                    332.450864,
                    939.637785
                ],
                [
                    330.420593,
                    941.846404
                ],
                [
                    328.385011,
                    944.050129
                ],
                [
                    326.343774,
                    946.248617
                ],
                [
                    324.296525,
                    948.441509
                ],
                [
                    322.242901,
                    950.628431
                ],
                [
                    320.182525,
                    952.808993
                ],
                [
                    318.115008,
                    954.982785
                ],
                [
                    316.039951,
                    957.149381
                ],
                [
                    313.956942,
                    959.308333
                ],
                [
                    311.865554,
                    961.45917
                ],
                [
                    309.76535,
                    963.601398
                ],
                [
                    307.655876,
                    965.734499
                ],
                [
                    305.536664,
                    967.857926
                ],
                [
                    303.407232,
                    969.971104
                ],
                [
                    301.267082,
                    972.073425
                ],
                [
                    299.115699,
                    974.164251
                ],
                [
                    296.952553,
                    976.242904
                ],
                [
                    294.777096,
                    978.308669
                ],
                [
                    292.588765,
                    980.360792
                ],
                [
                    290.386979,
                    982.398472
                ],
                [
                    288.171139,
                    984.42086
                ],
                [
                    285.940631,
                    986.427059
                ],
                [
                    283.694824,
                    988.416116
                ],
                [
                    281.433069,
                    990.387021
                ],
                [
                    279.154704,
                    992.338701
                ],
                [
                    276.859054,
                    994.270018
                ],
                [
                    274.545428,
                    996.179766
                ],
                [
                    272.213127,
                    998.066661
                ],
                [
                    269.861444,
                    999.929344
                ],
                [
                    267.489666,
                    1001.766371
                ],
                [
                    265.09708,
                    1003.576214
                ],
                [
                    262.682974,
                    1005.357251
                ],
                [
                    260.246648,
                    1007.10777
                ],
                [
                    257.787414,
                    1008.825957
                ],
                [
                    255.304608,
                    1010.509903
                ],
                [
                    252.797596,
                    1012.157596
                ],
                [
                    250.265785,
                    1013.766923
                ],
                [
                    247.708633,
                    1015.335672
                ],
                [
                    245.125661,
                    1016.861534
                ],
                [
                    242.516468,
                    1018.342113
                ],
                [
                    239.880743,
                    1019.774926
                ],
                [
                    237.218281,
                    1021.157422
                ],
                [
                    234.528999,
                    1022.486994
                ],
                [
                    231.812951,
                    1023.760998
                ],
                [
                    229.070345,
                    1024.976773
                ],
                [
                    226.301554,
                    1026.131674
                ],
                [
                    223.507131,
                    1027.223095
                ],
                [
                    220.687817,
                    1028.248507
                ],
                [
                    217.84455,
                    1029.205498
                ],
                [
                    214.978462,
                    1030.091806
                ],
                [
                    212.090881,
                    1030.905362
                ],
                [
                    209.183317,
                    1031.644331
                ],
                [
                    206.257454,
                    1032.307144
                ],
                [
                    203.315122,
                    1032.892536
                ],
                [
                    200.358279,
                    1033.399568
                ],
                [
                    197.388979,
                    1033.827652
                ],
                [
                    194.409337,
                    1034.176555
                ],
                [
                    191.421498,
                    1034.446408
                ],
                [
                    188.427603,
                    1034.637695
                ],
                [
                    185.429752,
                    1034.75124
                ],
                [
                    182.42998,
                    1034.78818
                ],
                [
                    179.430224,
                    1034.749937
                ],
                [
                    176.432306,
                    1034.638184
                ],
                [
                    173.437916,
                    1034.454805
                ],
                [
                    170.448599,
                    1034.201856
                ],
                [
                    167.46575,
                    1033.881524
                ],
                [
                    164.490613,
                    1033.49609
                ],
                [
                    161.524282,
                    1033.047892
                ],
                [
                    158.567709,
                    1032.539292
                ],
                [
                    155.621709,
                    1031.972645
                ],
                [
                    152.686977,
                    1031.350275
                ],
                [
                    149.764091,
                    1030.674451
                ],
                [
                    146.853532,
                    1029.947369
                ],
                [
                    143.955695,
                    1029.171134
                ],
                [
                    141.070901,
                    1028.34775
                ],
                [
                    138.19941,
                    1027.479108
                ],
                [
                    135.341436,
                    1026.566974
                ],
                [
                    132.497161,
                    1025.612985
                ],
                [
                    129.666741,
                    1024.618639
                ],
                [
                    126.850327,
                    1023.58529
                ],
                [
                    124.048072,
                    1022.514135
                ],
                [
                    121.260152,
                    1021.40621
                ],
                [
                    118.486772,
                    1020.262372
                ],
                [
                    115.728194,
                    1019.083285
                ],
                [
                    112.984752,
                    1017.869395
                ],
                [
                    110.256886,
                    1016.620897
                ],
                [
                    107.545176,
                    1015.337687
                ],
                [
                    104.850398,
                    1014.01929
                ],
                [
                    102.173604,
                    1012.664753
                ],
                [
                    99.516247,
                    1011.272469
                ],
                [
                    96.880398,
                    1009.839884
                ],
                [
                    94.269133,
                    1008.362962
                ],
                [
                    91.687353,
                    1006.835084
                ],
                [
                    89.425522,
                    1005.4206
                ],
                [
                    87.925166,
                    1004.419902
                ],
                [
                    86.937583,
                    1003.722652
                ],
                [
                    86.290571,
                    1003.242051
                ],
                [
                    85.867785,
                    1002.913372
                ],
                [
                    85.591847,
                    1002.689903
                ],
                [
                    85.411802,
                    1002.538647
                ],
                [
                    85.294289,
                    1002.436626
                ],
                [
                    85.21754,
                    1002.368008
                ],
                [
                    85.167373,
                    1002.321961
                ],
                [
                    85.134549,
                    1002.29112
                ],
                [
                    85.113053,
                    1002.270496
                ],
                [
                    85.098962,
                    1002.256723
                ],
                [
                    85.089717,
                    1002.247536
                ],
                [
                    85.083646,
                    1002.241413
                ],
                [
                    85.079656,
                    1002.237337
                ],
                [
                    85.077032,
                    1002.234625
                ],
                [
                    85.075306,
                    1002.232821
                ],
                [
                    85.074169,
                    1002.231623
                ],
                [
                    85.07342,
                    1002.230827
                ],
                [
                    85.072926,
                    1002.230299
                ],
                [
                    85.0726,
                    1002.229948
                ],
                [
                    85.072386,
                    1002.229716
                ],
                [
                    85.072244,
                    1002.229561
                ],
                [
                    85.07215,
                    1002.229459
                ],
                [
                    85.072089,
                    1002.229391
                ],
                [
                    85.072048,
                    1002.229346
                ],
                [
                    85.072021,
                    1002.229316
                ],
                [
                    85.072003,
                    1002.229297
                ],
                [
                    85.071991,
                    1002.229284
                ]
            ],
            "cumulative": [
                0,
                3.000001,
                6,
                9.000001,
                12,
                15,
                18.000001,
                21,
                24,
                27,
                30,
                33,
                36,
                39,
                42,
                45,
                48,
                51.000001,
                54,
                57.000001,
                60,
                63.000001,
                66,
                69,
                72.000001,
                75.000001,
                78,
                81,
                84.000001,
                87,
                90,
                93.000001,
                96,
                99,
                102,
                105,
                108,
                111,
                114.000001,
                117,
                120,
                123.000001,
                126.000001,
                129,
                132,
                135.000001,
                138.000001,
                141,
                144,
                147,
                150,
                153,
                156.000001,
                159,
                162,
                165.000001,
                168,
                171,
                174,
                177,
                180,
                183.000001,
                186,
                189,
                192,
                195.000001,
                198,
                201,
                204,
                207.000001,
                210,
                213.000001,
                216,
                219,
                222,
                225,
                228,
                231,
                234,
                237,
                240,
                243,
                246.000001,
                249,
                252,
                255,
                258,
                261,
                264,
                267,
                270,
                273,
                276,
                279,
                282.000001,
                285,
                288.000001,
                291,
                294,
                297.000001,
                300,
                303,
                306,
                309,
                312,
                315,
                318.000001,
                321.000001,
                324,
                327.000001,
                330,
                333,
                336,
                339,
                342.000001,
                345,
                348,
                351.000001,
                354,
                357,
                360,
                363,
                366.000001,
                369.000001,
                372.000001,
                375,
                378.000001,
                381.000001,
                384,
                387,
                390,
                393,
                396.000001,
                399.000001,
                402,
                405.000001,
                408.000001,
                411.000001,
                414.000001,
                417,
                420.000001,
                423.000001,
                426,
                429,
                432,
                435,
                438,
                441.000001,
                444.000001,
                447,
                450.000001,
                453.000001,
                456.000001,
                459.000001,
                462,
                465.000001,
                468.000001,
                471.000001,
                474.000001,
                477,
                480,
                483,
                486,
                489,
                492,
                495,
                498,
                501.000001,
                504,
                507,
                510.000001,
                513.000001,
                516,
                519.000001,
                522,
                525,
                528,
                531.000001,
                534.000001,
                537.000001,
                540,
                543,
                546.000001,
                549,
                552,
                555,
                558.000001,
                561,
                564,
                567,
                570.000001,
                573,
                576,
                579,
                582.000001,
                585.000001,
                588,
                591.000001,
                594.000001,
                597.000001,
                600,
                603.000001,
                606,
                609,
                612,
                615,
                618,
                621.000001,
                624,
                627.000001,
                630,
                633,
                636.000001,
                639,
                642,
                645.000001,
                648,
                651.000001,
                654,
                657,
                660,
                663,
                666,
                669,
                672,
                675,
                678,
                681.000001,
                684,
                687,
                690.000001,
                693.000001,
                696,
                699,
                702.000001,
                705,
                708,
                711,
                714.000001,
                717,
                720,
                723,
                726.000001,
                729.000001,
                732.000001,
                735,
                738,
                741,
                744,
                747.000001,
                750,
                752.667704,
                754.471163,
                755.680079,
                756.486058,
                757.021575,
                757.376652,
                757.6118,
                757.76742,
                757.870371,
                757.938467,
                757.983507,
                758.013297,
                758.033001,
                758.046034,
                758.054657,
                758.06036,
                758.064134,
                758.066631,
                758.068282,
                758.069375,
                758.070098,
                758.070578,
                758.070893,
                758.071103,
                758.071242,
                758.071333,
                758.071394,
                758.071435,
                758.071461,
                758.071479
            ],
            "length": 758.071479,
            "stops": [
                0,
                107.220052,
                208.189007,
                302.637069,
                390.248612,
                470.646928,
                543.370577,
                607.834152,
                663.256736,
                708.511643,
                741.72283,
                758.071479
            ]
        },
        {
            "points": [
                [
                    1002.676141,
                    878.535286
                ],
                [
                    1005.495331,
                    879.561038
                ],
                [
                    1008.31749,
                    880.578596
                ],
                [
                    1011.142289,
                    881.588797
                ],
                [
                    1013.969441,
                    882.592397
                ],
                [
                    1016.798689,
                    883.590071
                ],
                [
                    1019.629807,
                    884.58243
                ],
                [
                    1022.462591,
                    885.57002
                ],
                [
                    1025.296862,
                    886.553334
                ],
                [
                    1028.132459,
                    887.532817
                ],
                [
                    1030.96924,
                    888.508867
                ],
                [
                    1033.807077,
                    889.481844
                ],
                [
                    1036.645854,
                    890.452072
                ],
                [
                    1039.485471,
                    891.41984
                ],
                [
                    1042.325836,
                    892.385411
                ],
                [
                    1045.166868,
                    893.349017
                ],
                [
                    1048.008494,
                    894.31087
                ],
                [
                    1050.85065,
                    895.271158
                ],
                [
                    1053.693278,
                    896.230047
                ],
                [
                    1056.536326,
                    897.187687
                ],
                [
                    1059.379751,
                    898.14421
                ],
                [
                    1062.223511,
                    899.099733
                ],
                [
                    1065.067573,
                    900.05436
                ],
                [
                    1067.911906,
                    901.00818
                ],
                [
                    1070.756483,
                    901.961271
                ],
                [
                    1073.601281,
                    902.9137
                ],
                [
                    1076.446282,
                    903.865525
                ],
                [
                    1079.291469,
                    904.816793
                ],
                [
                    1082.136829,
                    905.767544
                ],
                [
                    1084.982351,
                    906.717809
                ],
                [
                    1087.828027,
                    907.667612
                ],
                [
                    1090.673852,
                    908.616971
                ],
                [
                    1093.519821,
                    909.565898
                ],
                [
                    1096.365932,
                    910.514396
                ],
                [
                    1099.212186,
                    911.462467
                ],
                [
                    1102.058584,
                    912.410105
                ],
                [
                    1104.90513,
                    913.3573
                ],
                [
                    1107.751827,
                    914.304038
                ],
                [
                    1110.598683,
                    915.250301
                ],
                [
                    1113.445704,
                    916.196066
                ],
                [
                    1116.292899,
                    917.141308
                ],
                [
                    1119.140277,
                    918.085998
                ],
                [
                    1121.987849,
                    919.030102
                ],
                [
                    1124.835627,
                    919.973585
                ],
                [
                    1127.683623,
                    920.91641
                ],
                [
                    1130.531851,
                    921.858534
                ],
                [
                    1133.380325,
                    922.799914
                ],
                [
                    1136.229059,
                    923.740505
                ],
                [
                    1139.078071,
                    924.680256
                ],
                [
                    1141.927376,
                    925.619118
                ],
                [
                    1144.776991,
                    926.557037
                ],
                [
                    1147.626935,
                    927.493959
                ],
                [
                    1150.477225,
                    928.429825
                ],
                [
                    1153.327881,
                    929.364577
                ],
                [
                    1156.178922,
                    930.298154
                ],
                [
                    1159.030368,
                    931.230492
                ],
                [
                    1161.88224,
                    932.161527
                ],
                [
                    1164.734559,
                    933.091192
                ],
                [
                    1167.587346,
                    934.019419
                ],
                [
                    1170.440624,
                    934.946137
                ],
                [
                    1173.294414,
                    935.871276
                ],
                [
                    1176.14874,
                    936.79476
                ],
                [
                    1179.003625,
                    937.716516
                ],
                [
                    1181.859092,
                    938.636465
                ],
                [
                    1184.715166,
                    939.554529
                ],
                [
                    1187.57187,
                    940.470629
                ],
                [
                    1190.429231,
                    941.384682
                ],
                [
                    1193.287272,
                    942.296603
                ],
                [
                    1196.146019,
                    943.206309
                ],
                [
                    1199.005498,
                    944.113711
                ],
                [
                    1201.865735,
                    945.018722
                ],
                [
                    1204.726757,
                    945.921249
                ],
                [
                    1207.588589,
                    946.821201
                ],
                [
                    1210.45126,
                    947.718484
                ],
                [
                    1213.314796,
                    948.613001
                ],
                [
                    1216.179225,
                    949.504655
                ],
                [
                    1219.044575,
                    950.393346
                ],
                [
                    1221.910873,
                    951.278972
                ],
                [
                    1224.778149,
                    952.161429
                ],
                [
                    1227.64643,
                    953.040612
                ],
                [
                    1230.515746,
                    953.916414
                ],
                [
                    1233.386124,
                    954.788724
                ],
                [
                    1236.257596,
                    955.65743
                ],
                [
                    1239.13019,
                    956.52242
                ],
                [
                    1242.003935,
                    957.383575
                ],
                [
                    1244.878861,
                    958.240779
                ],
                [
                    1247.754999,
                    959.09391
                ],
                [
                    1250.632377,
                    959.942846
                ],
                [
                    1253.511027,
                    960.78746
                ],
                [
                    1256.390979,
                    961.627626
                ],
                [
                    1259.272263,
                    962.463212
                ],
                [
                    1262.154909,
                    963.294087
                ],
                [
                    1265.038947,
                    964.120114
                ],
                [
                    1267.924409,
                    964.941156
                ],
                [
                    1270.811325,
                    965.757071
                ],
                [
                    1273.699725,
                    966.567717
                ],
                [
                    1276.589639,
                    967.372947
                ],
                [
                    1279.481098,
                    968.172613
                ],
                [
                    1282.374132,
                    968.966562
                ],
                [
                    1285.268771,
                    969.754639
                ],
                [
                    1288.165044,
                    970.536688
                ],
                [
                    1291.062982,
                    971.312547
                ],
                [
                    1293.962613,
                    972.082053
                ],
                [
                    1296.863966,
                    972.845039
                ],
                [
                    1299.767071,
                    973.601335
                ],
                [
                    1302.671955,
                    974.350769
                ],
                [
                    1305.578645,
                    975.093164
                ],
                [
                    1308.487169,
                    975.828342
                ],
                [
                    1311.397554,
                    976.55612
                ],
                [
                    1314.309825,
                    977.276312
                ],
                [
                    1317.224007,
                    977.988732
                ],
                [
                    1320.140125,
                    978.693186
                ],
                [
                    1323.058202,
                    979.389482
                ],
                [
                    1325.978261,
                    980.07742
                ],
                [
                    1328.900322,
                    980.756802
                ],
                [
                    1331.824405,
                    981.427424
                ],
                [
                    1334.750531,
                    982.089079
                ],
                [
                    1337.678716,
                    982.741561
                ],
                [
                    1340.608977,
                    983.384657
                ],
                [
                    1343.541327,
                    984.018156
                ],
                [
                    1346.475781,
                    984.641841
                ],
                [
                    1349.412348,
                    985.255495
                ],
                [
                    1352.351039,
                    985.858901
                ],
                [
                    1355.291859,
                    986.451839
                ],
                [
                    1358.234814,
                    987.034088
                ],
                [
                    1361.179907,
                    987.605427
                ],
                [
                    1364.127138,
                    988.165634
                ],
                [
                    1367.076503,
                    988.714491
                ],
                [
                    1370.027998,
                    989.251776
                ],
                [
                    1372.981615,
                    989.777274
                ],
                [
                    1375.937343,
                    990.290768
                ],
                [
                    1378.895166,
                    990.792047
                ],
                [
                    1381.855068,
                    991.280904
                ],
                [
                    1384.817027,
                    991.757139
                ],
                [
                    1387.781018,
                    992.220555
                ],
                [
                    1390.747014,
                    992.670966
                ],
                [
                    1393.714981,
                    993.108195
                ],
                [
                    1396.684884,
                    993.532078
                ],
                [
                    1399.656682,
                    993.942462
                ],
                [
                    1402.630331,
                    994.339212
                ],
                [
                    1405.605783,
                    994.722212
                ],
                [
                    1408.582984,
                    995.091364
                ],
                [
                    1411.561878,
                    995.446601
                ],
                [
                    1414.542402,
                    995.787881
                ],
                [
                    1417.524493,
                    996.115199
                ],
                [
                    1420.508079,
                    996.428587
                ],
                [
                    1423.493088,
                    996.728126
                ],
                [
                    1426.479441,
                    997.01395
                ],
                [
                    1429.467057,
                    997.286256
                ],
                [
                    1432.45585,
                    997.545318
                ],
                [
                    1435.445733,
                    997.791495
                ],
                [
                    1438.436612,
                    998.025255
                ],
                [
                    1441.428391,
                    998.247193
                ],
                [
                    1444.420971,
                    998.458056
                ],
                [
                    1447.414249,
                    998.658781
                ],
                [
                    1450.408114,
                    998.850541
                ],
                [
                    1453.402449,
                    999.034806
                ],
                [
                    1456.397127,
                    999.213427
                ],
                [
                    1459.391999,
                    999.388757
                ],
                [
                    1462.386887,
                    999.563827
                ],
                [
                    1465.381554,
                    999.742617
                ],
                [
                    1468.375666,
                    999.93048
                ],
                [
                    1471.368695,
                    1000.134883
                ],
                [
                    1474.35972,
                    1000.366763
                ],
                [
                    1477.346939,
                    1000.643387
                ],
                [
                    1480.293186,
                    1000.991554
                ],
                [
                    1482.092703,
                    1001.291413
                ],
                [
                    1483.202794,
                    1001.535874
                ],
                [
                    1483.892992,
                    1001.726565
                ],
                [
                    1484.324899,
                    1001.870433
                ],
                [
                    1484.596654,
                    1001.97628
                ],
                [
                    1484.768452,
                    1002.052673
                ],
                [
                    1484.877516,
                    1002.106992
                ],
                [
                    1484.947016,
                    1002.145163
                ],
                [
                    1484.991454,
                    1002.171735
                ],
                [
                    1485.019958,
                    1002.190092
                ],
                [
                    1485.038293,
                    1002.202694
                ],
                [
                    1485.050118,
                    1002.2113
                ],
                [
                    1485.057764,
                    1002.217152
                ],
                [
                    1485.062718,
                    1002.221116
                ],
                [
                    1485.065934,
                    1002.223793
                ],
                [
                    1485.068026,
                    1002.225597
                ],
                [
                    1485.06939,
                    1002.226809
                ],
                [
                    1485.07028,
                    1002.227622
                ],
                [
                    1485.070861,
                    1002.228166
                ],
                [
                    1485.071242,
                    1002.22853
                ],
                [
                    1485.071491,
                    1002.228773
                ],
                [
                    1485.071655,
                    1002.228935
                ],
                [
                    1485.071762,
                    1002.229043
                ],
                [
                    1485.071832,
                    1002.229115
                ],
                [
                    1485.071879,
                    1002.229163
                ],
                [
                    1485.071909,
                    1002.229195
                ],
                [
                    1485.071929,
                    1002.229216
                ],
                [
                    1485.071943,
                    1002.22923
                ]
            ],
            "cumulative": [
                0,
                3,
                6.000001,
                9,
                12,
                15,
                18.000001,
                21.000001,
                24,
                27,
                30,
                33.000001,
                36,
                39,
                42,
                45,
                48,
                51.000001,
                54.000001,
                57,
                60.000001,
                63,
                66,
                69.000001,
                72.000001,
                75,
                78,
                81,
                84,
                87,
                90,
                93,
                96.000001,
                99,
                102,
                105,
                108,
                111,
                114,
                117,
                120.000001,
                123.000001,
                126.000001,
                129,
                132.000001,
                135.000001,
                138.000001,
                141,
                144,
                147,
                150,
                153.000001,
                156,
                159.000001,
                162.000001,
                165,
                168,
                171.000001,
                174,
                177.000001,
                180.000001,
                183.000001,
                186.000001,
                189.000001,
                192.000001,
                195,
                198.000001,
                201.000001,
                204.000001,
                207,
                210,
                213.000001,
                216,
                219,
                222,
                225,
                228.000001,
                231,
                234.000001,
                237,
                240.000001,
                243,
                246,
                249.000001,
                252.000001,
                255,
                258.000001,
                261,
                264,
                267,
                270.000001,
                273.000001,
                276,
                279,
                282,
                285.000001,
                288,
                291.000001,
                294.000001,
                297.000001,
                300,
                303.000001,
                306.000001,
                309,
                312,
                315.000001,
                318,
                321,
                324,
                327,
                330,
                333,
                336,
                339.000001,
                342.000001,
                345,
                348,
                351,
                354.000001,
                357,
                360.000001,
                363,
                366.000001,
                369,
                372,
                375,
                378.000001,
                381,
                384,
                387,
                390.000001,
                393,
                396.000001,
                399.000001,
                402,
                405.000001,
                408,
                411,
                414,
                417,
                420.000001,
                423,
                426.000001,
                429,
                432.000001,
                435,
                438.000001,
                441.000001,
                444.000001,
                447,
                450.000001,
                453.000001,
                456,
                459,
                462.000001,
                465.000001,
                468,
                471,
                474,
                477.000001,
                480,
                483,
                486,
                489,
                492,
                494.966748,
                496.791077,
                497.927766,
                498.643822,
                499.09906,
                499.390701,
                499.578718,
                499.700561,
                499.779853,
                499.831629,
                499.865533,
                499.887781,
                499.902406,
                499.912035,
                499.91838,
                499.922564,
                499.925326,
                499.927151,
                499.928356,
                499.929152,
                499.929679,
                499.930027,
                499.930258,
                499.93041,
                499.93051,
                499.930577,
                499.930621,
                499.93065,
                499.93067
            ],
            "length": 499.93067,
            "stops": [
                0,
                96.171252,
                184.42454,
                264.25334,
                335.015052,
                395.852461,
                445.528804,
                481.984747,
                499.93067
            ]
        },
        {
            "points": [
                [
                    423.352149,
                    859.436693
                ],
                [
                    421.416117,
                    861.728369
                ],
                [
                    419.483458,
                    864.022891
                ],
                [
                    417.554007,
                    866.320111
                ],
                [
                    415.627597,
                    868.619881
                ],
                [
                    413.704059,
                    870.922054
                ],
                [
                    411.783221,
                    873.226481
                ],
                [
                    409.86491,
                    875.533012
                ],
                [
                    407.948951,
                    877.841496
                ],
                [
                    406.035166,
                    880.151783
                ],
                [
                    404.123375,
                    882.463721
                ],
                [
                    402.213396,
                    884.777155
                ],
                [
                    400.305044,
                    887.091933
                ],
                [
                    398.398133,
                    889.407896
                ],
                [
                    396.492472,
                    891.72489
                ],
                [
                    394.587872,
                    894.042754
                ],
                [
                    392.684136,
                    896.361329
                ],
                [
                    390.781067,
                    898.680452
                ],
                [
                    388.878466,
                    900.999958
                ],
                [
                    386.976129,
                    903.319681
                ],
                [
                    385.073851,
                    905.639452
                ],
                [
                    383.17142,
                    907.959098
                ],
                [
                    381.268625,
                    910.278445
                ],
                [
                    379.365247,
                    912.597314
                ],
                [
                    377.461068,
                    914.915525
                ],
                [
                    375.55586,
                    917.23289
                ],
                [
                    373.649396,
                    919.549223
                ],
                [
                    371.741442,
                    921.864327
                ],
                [
                    369.831758,
                    924.178006
                ],
                [
                    367.920101,
                    926.490054
                ],
                [
                    366.006222,
                    928.800263
                ],
                [
                    364.089866,
                    931.108418
                ],
                [
                    362.170772,
                    933.414297
                ],
                [
                    360.248672,
                    935.717672
                ],
                [
                    358.323294,
                    938.018306
                ],
                [
                    356.394354,
                    940.315955
                ],
                [
                    354.461565,
                    942.610367
                ],
                [
                    352.524631,
                    944.901281
                ],
                [
                    350.583245,
                    947.188423
                ],
                [
                    348.637094,
                    949.471512
                ],
                [
                    346.685854,
                    951.750254
                ],
                [
                    344.729193,
                    954.024342
                ],
                [
                    342.766766,
                    956.293457
                ],
                [
                    340.79822,
                    958.557265
                ],
                [
                    338.823187,
                    960.815415
                ],
                [
                    336.841289,
                    963.067543
                ],
                [
                    334.852135,
                    965.313265
                ],
                [
                    332.85532,
                    967.552178
                ],
                [
                    330.850425,
                    969.783858
                ],
                [
                    328.837015,
                    972.007859
                ],
                [
                    326.814642,
                    974.223712
                ],
                [
                    324.782838,
                    976.430922
                ],
                [
                    322.741121,
                    978.628964
                ],
                [
                    320.688988,
                    980.817286
                ],
                [
                    318.625921,
                    982.995302
                ],
                [
                    316.551378,
                    985.16239
                ],
                [
                    314.4648,
                    987.317893
                ],
                [
                    312.365607,
                    989.461112
                ],
                [
                    310.253194,
                    991.591303
                ],
                [
                    308.126937,
                    993.707675
                ],
                [
                    305.986188,
                    995.809388
                ],
                [
                    303.830276,
                    997.895542
                ],
                [
                    301.658506,
                    999.965183
                ],
                [
                    299.470159,
                    1002.017289
                ],
                [
                    297.264493,
                    1004.050768
                ],
                [
                    295.040744,
                    1006.064457
                ],
                [
                    292.798126,
                    1008.057109
                ],
                [
                    290.53583,
                    1010.027393
                ],
                [
                    288.253031,
                    1011.973884
                ],
                [
                    285.948887,
                    1013.895061
                ],
                [
                    283.622543,
                    1015.789295
                ],
                [
                    281.273134,
                    1017.654846
                ],
                [
                    278.899795,
                    1019.489856
                ],
                [
                    276.501663,
                    1021.292343
                ],
                [
                    274.077886,
                    1023.060196
                ],
                [
                    271.627634,
                    1024.791169
                ],
                [
                    269.150111,
                    1026.482878
                ],
                [
                    266.644566,
                    1028.1328
                ],
                [
                    264.11031,
                    1029.738274
                ],
                [
                    261.546734,
                    1031.296503
                ],
                [
                    258.953328,
                    1032.804564
                ],
                [
                    256.329703,
                    1034.259414
                ],
                [
                    253.675612,
                    1035.657914
                ],
                [
                    250.990977,
                    1036.996845
                ],
                [
                    248.275911,
                    1038.27294
                ],
                [
                    245.530744,
                    1039.482921
                ],
                [
                    242.756039,
                    1040.62354
                ],
                [
                    239.952614,
                    1041.691627
                ],
                [
                    237.121554,
                    1042.68415
                ],
                [
                    234.264216,
                    1043.598272
                ],
                [
                    231.382225,
                    1044.431413
                ],
                [
                    228.477461,
                    1045.181313
                ],
                [
                    225.552043,
                    1045.846089
                ],
                [
                    222.608289,
                    1046.424286
                ],
                [
                    219.648681,
                    1046.914918
                ],
                [
                    216.675815,
                    1047.317498
                ],
                [
                    213.692351,
                    1047.632044
                ],
                [
                    210.700954,
                    1047.859084
                ],
                [
                    207.704248,
                    1047.999631
                ],
                [
                    204.704762,
                    1048.055152
                ],
                [
                    201.704889,
                    1048.027525
                ],
                [
                    198.706853,
                    1047.91898
                ],
                [
                    195.712683,
                    1047.732045
                ],
                [
                    192.724195,
                    1047.469479
                ],
                [
                    189.742988,
                    1047.134214
                ],
                [
                    186.77044,
                    1046.729299
                ],
                [
                    183.807717,
                    1046.25784
                ],
                [
                    180.855785,
                    1045.722961
                ],
                [
                    177.915422,
                    1045.127756
                ],
                [
                    174.98724,
                    1044.475263
                ],
                [
                    172.071697,
                    1043.768431
                ],
                [
                    169.169123,
                    1043.010103
                ],
                [
                    166.279732,
                    1042.202997
                ],
                [
                    163.403643,
                    1041.3497
                ],
                [
                    160.540898,
                    1040.452656
                ],
                [
                    157.69147,
                    1039.514166
                ],
                [
                    154.855286,
                    1038.536384
                ],
                [
                    152.032231,
                    1037.521318
                ],
                [
                    149.222162,
                    1036.470835
                ],
                [
                    146.42492,
                    1035.386661
                ],
                [
                    143.640333,
                    1034.270382
                ],
                [
                    140.86823,
                    1033.123453
                ],
                [
                    138.108443,
                    1031.947198
                ],
                [
                    135.360815,
                    1030.742814
                ],
                [
                    132.625208,
                    1029.511371
                ],
                [
                    129.901505,
                    1028.253817
                ],
                [
                    127.18962,
                    1026.970977
                ],
                [
                    124.489503,
                    1025.663549
                ],
                [
                    121.801148,
                    1024.332103
                ],
                [
                    119.124602,
                    1022.977074
                ],
                [
                    116.459976,
                    1021.598754
                ],
                [
                    113.807459,
                    1020.197271
                ],
                [
                    111.167337,
                    1018.772577
                ],
                [
                    108.540019,
                    1017.324405
                ],
                [
                    105.926074,
                    1015.852233
                ],
                [
                    103.326284,
                    1014.355205
                ],
                [
                    100.74173,
                    1012.832024
                ],
                [
                    98.173923,
                    1011.280776
                ],
                [
                    95.625048,
                    1009.698614
                ],
                [
                    93.098412,
                    1008.081176
                ],
                [
                    90.599439,
                    1006.421316
                ],
                [
                    88.713843,
                    1005.106923
                ],
                [
                    87.462607,
                    1004.190355
                ],
                [
                    86.638062,
                    1003.55852
                ],
                [
                    86.096968,
                    1003.126561
                ],
                [
                    85.742701,
                    1002.833046
                ],
                [
                    85.510998,
                    1002.634518
                ],
                [
                    85.359492,
                    1002.500713
                ],
                [
                    85.260401,
                    1002.410783
                ],
                [
                    85.195553,
                    1002.350476
                ],
                [
                    85.153085,
                    1002.31011
                ],
                [
                    85.125251,
                    1002.283132
                ],
                [
                    85.106992,
                    1002.265125
                ],
                [
                    85.095006,
                    1002.253119
                ],
                [
                    85.087131,
                    1002.245121
                ],
                [
                    85.081954,
                    1002.239799
                ],
                [
                    85.078548,
                    1002.236258
                ],
                [
                    85.076305,
                    1002.233905
                ],
                [
                    85.074828,
                    1002.232342
                ],
                [
                    85.073855,
                    1002.231304
                ],
                [
                    85.073214,
                    1002.230615
                ],
                [
                    85.07279,
                    1002.230158
                ],
                [
                    85.072511,
                    1002.229854
                ],
                [
                    85.072327,
                    1002.229653
                ],
                [
                    85.072205,
                    1002.22952
                ],
                [
                    85.072125,
                    1002.229432
                ],
                [
                    85.072072,
                    1002.229373
                ],
                [
                    85.072037,
                    1002.229334
                ],
                [
                    85.072013,
                    1002.229308
                ],
                [
                    85.071998,
                    1002.229291
                ],
                [
                    85.071988,
                    1002.22928
                ]
            ],
            "cumulative": [
                0,
                3,
                6,
                9,
                12,
                15,
                18,
                21,
                24,
                27,
                30,
                33,
                36,
                38.999999,
                42,
                44.999999,
                48,
                51,
                54,
                57,
                60,
                63,
                66,
                69,
                72,
                75,
                78,
                81,
                84,
                87,
                90,
                93,
                96,
                99,
                102,
                105,
                108,
                111,
                114,
                117,
                120,
                123,
                126,
                129,
                132,
                135,
                138,
                141,
                144,
                147,
                150,
                153,
                156,
                159,
                162,
                165,
                168,
                171,
                174,
                177,
                180.000001,
                183,
                186,
                189,
                192,
                195,
                198,
                201,
                204,
                207,
                210,
                213,
                216,
                219,
                222,
                225,
                228,
                231,
                234,
                237,
                240,
                243,
                246,
                249,
                252,
                255,
                258,
                261,
                264,
                267,
                270,
                273,
                276,
                279,
                282,
                285,
                287.999999,
                291,
                294,
                297,
                300,
                303,
                306,
                309,
                312,
                315,
                318,
                321,
                324,
                327,
                330,
                333,
                336,
                339,
                342,
                345,
                348,
                351,
                354,
                356.999999,
                360,
                363,
                366,
                369,
                372,
                375,
                378,
                381,
                384,
                387,
                390,
                393,
                395.999999,
                399,
                402,
                405,
                408,
                411,
                414,
                416.999999,
                420,
                422.298499,
                423.849528,
                424.88832,
                425.580687,
                426.040748,
                426.34587,
                426.548003,
                426.681818,
                426.770374,
                426.828966,
                426.867728,
                426.893373,
                426.910338,
                426.921562,
                426.928987,
                426.9339,
                426.937151,
                426.939301,
                426.940724,
                426.941665,
                426.942288,
                426.942701,
                426.942973,
                426.943154,
                426.943273,
                426.943352,
                426.943405,
                426.94344,
                426.943463,
                426.943477
            ],
            "length": 426.943477,
            "stops": [
                0,
                93.320834,
                177.733443,
                252.558325,
                316.889048,
                369.41783,
                407.967091,
                426.943477
            ]
        }
    ]
};


var $4697fcb9dfd04058$exports = {};
$4697fcb9dfd04058$exports = JSON.parse("{\"text\":\"M L Newton\",\"source\":\"Lufga-ExtraBold.ttf; HarfBuzz shaping at 204px with -8px letter spacing; baseline-relative SVG outlines\",\"path\":\"M124.412 -140.748H167.244V0H132.182V-84.469L100.008 -22.213H79.986L47.713 -84.469V0H12.65V-140.748H56.08L90.146 -75.105ZM255.037 -33.07H311.117V0H219.975V-140.748H255.037ZM443.037 -140.748H478.1V0H443.037L390.145 -79.389V0H355.082V-140.748H390.145L443.037 -61.16ZM598.297 -51.398Q598.297 -45.621 597.5 -42.035H523.291Q525.881 -34.465 532.106 -30.182Q538.332 -25.898 546.898 -25.898Q554.17 -25.898 560.495 -28.887Q566.82 -31.875 570.605 -36.059L592.42 -17.133Q583.953 -7.869 571.9 -2.689Q559.848 2.49 545.902 2.49Q521 2.49 504.365 -13.298Q487.73 -29.086 487.73 -52.594Q487.73 -67.635 494.952 -79.986Q502.174 -92.338 514.924 -99.41Q527.674 -106.482 543.213 -106.482Q554.867 -106.482 565.077 -102.299Q575.287 -98.115 582.559 -90.894Q589.83 -83.672 594.063 -73.412Q598.297 -63.152 598.297 -51.398ZM543.014 -78.293Q536.041 -78.293 530.712 -74.06Q525.383 -69.826 523.092 -62.455H563.035Q560.844 -69.727 555.465 -74.01Q550.086 -78.293 543.014 -78.293ZM727.658 -103.992H763.717L727.658 0H693.791L676.658 -62.654L659.227 0H625.359L589.5 -103.992H626.455L643.189 -43.629L660.322 -103.992H693.791L710.924 -43.828ZM836.301 -73.811H810.801V-41.039Q810.801 -29.584 823.053 -29.584Q829.129 -29.584 836.301 -33.07V-2.291Q827.436 2.49 815.98 2.49Q796.756 2.49 787.293 -7.77Q777.83 -18.029 777.83 -35.461V-73.811H762.889V-103.992H777.83V-129.094H810.801V-103.992H836.301ZM894.143 2.49Q878.205 2.49 865.306 -4.632Q852.406 -11.754 845.135 -24.205Q837.863 -36.656 837.863 -51.996Q837.863 -67.336 845.135 -79.787Q852.406 -92.238 865.306 -99.36Q878.205 -106.482 894.143 -106.482Q918.148 -106.482 934.335 -90.844Q950.521 -75.205 950.521 -51.996Q950.521 -28.787 934.335 -13.148Q918.148 2.49 894.143 2.49ZM894.143 -29.584Q903.705 -29.584 910.08 -36.009Q916.455 -42.434 916.455 -51.996Q916.455 -61.658 910.03 -68.083Q903.605 -74.508 894.143 -74.508Q884.48 -74.508 878.105 -68.083Q871.73 -61.658 871.73 -51.996Q871.73 -42.334 878.105 -35.959Q884.48 -29.584 894.143 -29.584ZM1021.312 -106.482Q1038.943 -106.482 1049.751 -95.824Q1060.559 -85.166 1060.559 -67.535V0H1027.488V-56.479Q1027.488 -64.646 1022.757 -69.577Q1018.025 -74.508 1010.156 -74.508Q1001.689 -74.508 996.51 -69.428Q991.33 -64.348 991.33 -56.08V0H958.359V-103.992H991.33V-94.828Q1003.283 -106.482 1021.312 -106.482Z\"}");



var $4ACxo = parcelRequire("4ACxo");
function $d35456265291abd0$export$ccb823308650f28(hero) {
    const stage = hero.querySelector('.loss-contour-stage');
    if (!stage) return null;
    const makeSurface = ()=>{
        const element = document.createElement('canvas');
        return {
            element: element,
            context: element.getContext('2d')
        };
    };
    const display = makeSurface(), scene = makeSurface(), title = makeSurface();
    if (!display.context || !scene.context || !title.context) return null;
    const canvas = display.element;
    canvas.className = 'loss-contour-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    stage.append(canvas);
    const fields = [
        (0, $163eeaf116323931$export$2e2bcd8739ae039)
    ];
    // SVG and canvas use the same shaped Lufga outlines. Text APIs differ in
    // kerning/letter-spacing support on Safari, causing a jump at the handoff.
    // Use the authored outline, not the built SVG's d attribute: Parcel folds
    // SVG transforms into that path, which would apply the title placement twice.
    const titlePath = new Path2D((0, (/*@__PURE__*/$parcel$interopDefault($4697fcb9dfd04058$exports))).path);
    const mod = (v, n)=>(v % n + n) % n;
    const clamp = (v, a = 0, b = 1)=>Math.max(a, Math.min(b, v));
    const smooth = (t)=>t * t * (3 - 2 * t);
    const wrapX = 1400, wrapZ = 1200, focal = 800;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const dark = matchMedia('(prefers-color-scheme: dark)');
    const mobileMedia = matchMedia('(max-width: 700px)');
    const print = matchMedia('print');
    const abort = new AbortController(), signal = abort.signal;
    const v = {
        canvas: canvas,
        ctx: display.context,
        scene: scene,
        title: title,
        design: {
            layers: [
                {
                    field: 0,
                    rise: 370,
                    horizon: 64,
                    vp: 790,
                    offset: 820,
                    alpha: 1,
                    pace: 1,
                    phase: 0
                }
            ]
        },
        state: {
            speed: 10,
            cadence: 3.2,
            background: .74
        },
        visible: false,
        travel: 230,
        elapsed: 2.4,
        revealElapsed: 0,
        last: 0,
        nextDraw: 0,
        raf: 0,
        view: {
            pixelWidth: 0
        },
        paletteDirty: true,
        titleDirty: true,
        bands: []
    };
    let disposed = false, suspended = false, printing = false, ready = false, resizeRaf = 0;
    // Cache a seamless tile once per field/resolution; frames only resample the tile.
    const caches = new Map();
    function getField(index, width) {
        const key = index + ':' + width;
        if (caches.has(key)) return caches.get(key);
        const surface = makeSurface(), height = width, ratio = width / wrapX;
        surface.element.width = width;
        surface.element.height = height;
        surface.context.setTransform(ratio, 0, 0, height / wrapZ, 0, 0);
        surface.context.strokeStyle = '#fff';
        surface.context.lineWidth = 2.8;
        surface.context.lineJoin = 'round';
        surface.context.lineCap = 'round';
        surface.context.stroke(new Path2D(fields[index].contours));
        const result = {
            ...surface,
            width: width,
            height: height,
            ratio: ratio,
            patterns: new WeakMap()
        };
        caches.set(key, result);
        return result;
    }
    // Perspective-correct texture mapping keeps the contours smooth at every depth.
    const gpuCanvas = document.createElement('canvas');
    let gl = null, gpu = null, gpuAttempted = false, gpuIdle = 0;
    function initGpu() {
        if (!gl) return;
        function shader(type, source) {
            const s = gl.createShader(type);
            gl.shaderSource(s, source);
            gl.compileShader(s);
            if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
                gl.deleteShader(s);
                throw Error('Contour shader could not compile');
            }
            return s;
        }
        const vertex = shader(gl.VERTEX_SHADER, `attribute vec2 a_position;uniform vec4 u_view;uniform vec4 u_plane;uniform float u_scroll;varying vec2 v_uv;varying float v_z;void main(){float x=a_position.x;float z=a_position.y;float w=800.0+z;float p=800.0/w;float sx=u_plane.x+(x-u_plane.y+.08*z)*p;float sy=u_plane.z+u_plane.w*p;gl_Position=vec4((2.0*(sx-u_view.x)/u_view.y-1.0)*w,(1.0-2.0*sy/u_view.z)*w,0.0,w);v_uv=vec2(x/1400.0,(z-u_scroll)/1200.0);v_z=z;}`);
        const fragment = shader(gl.FRAGMENT_SHADER, `precision mediump float;uniform sampler2D u_texture;uniform float u_alpha;varying vec2 v_uv;varying float v_z;void main(){float p=800.0/(800.0+v_z);float fade=smoothstep(.22,.40,p)*(1.0-smoothstep(.915,1.0,p));float a=smoothstep(.045,.45,texture2D(u_texture,v_uv).a)*u_alpha*fade;gl_FragColor=vec4(a,a,a,a);}`);
        const program = gl.createProgram();
        gl.attachShader(program, vertex);
        gl.attachShader(program, fragment);
        gl.linkProgram(program);
        gl.deleteShader(vertex);
        gl.deleteShader(fragment);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            gl.deleteProgram(program);
            throw Error('Contour shader could not link');
        }
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
            -6000,
            0,
            6000,
            0,
            -6000,
            2836,
            -6000,
            2836,
            6000,
            0,
            6000,
            2836
        ]), gl.STATIC_DRAW);
        gpu = {
            program: program,
            buffer: buffer,
            extent: 6000,
            position: gl.getAttribLocation(program, 'a_position'),
            view: gl.getUniformLocation(program, 'u_view'),
            plane: gl.getUniformLocation(program, 'u_plane'),
            scroll: gl.getUniformLocation(program, 'u_scroll'),
            alpha: gl.getUniformLocation(program, 'u_alpha'),
            texture: gl.getUniformLocation(program, 'u_texture'),
            textures: new Map()
        };
    }
    function gpuTexture(index) {
        if (gpu.textures.has(index)) return gpu.textures.get(index);
        const tile = getField(index, 1024), texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, tile.element);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.generateMipmap(gl.TEXTURE_2D);
        const aniso = gl.getExtension('EXT_texture_filter_anisotropic');
        if (aniso) gl.texParameterf(gl.TEXTURE_2D, aniso.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(8, gl.getParameter(aniso.MAX_TEXTURE_MAX_ANISOTROPY_EXT)));
        gpu.textures.set(index, texture);
        return texture;
    }
    function drawTerrain(v) {
        if (!gpu) return false;
        const { pixelWidth: pixelWidth, pixelHeight: pixelHeight, width: width, height: height, left: left } = v.view;
        if (gpuCanvas.width !== pixelWidth || gpuCanvas.height !== pixelHeight) {
            gpuCanvas.width = pixelWidth;
            gpuCanvas.height = pixelHeight;
        }
        // Extend the same two triangles on panoramic screens; no extra mesh work.
        const extent = Math.max(6000, width * 3);
        if (gpu.extent !== extent) {
            gl.bindBuffer(gl.ARRAY_BUFFER, gpu.buffer);
            gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
                -extent,
                0,
                extent,
                0,
                -extent,
                2836,
                -extent,
                2836,
                extent,
                0,
                extent,
                2836
            ]), gl.STATIC_DRAW);
            gpu.extent = extent;
        }
        gl.viewport(0, 0, pixelWidth, pixelHeight);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(gpu.program);
        gl.bindBuffer(gl.ARRAY_BUFFER, gpu.buffer);
        gl.enableVertexAttribArray(gpu.position);
        gl.vertexAttribPointer(gpu.position, 2, gl.FLOAT, false, 0, 0);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.uniform4f(gpu.view, left, width, height, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.uniform1i(gpu.texture, 0);
        for (const layer of v.design.layers){
            gl.bindTexture(gl.TEXTURE_2D, gpuTexture(layer.field));
            gl.uniform4f(gpu.plane, layer.vp, layer.offset, layer.horizon, layer.rise);
            gl.uniform1f(gpu.scroll, mod(v.travel * layer.pace, wrapZ));
            gl.uniform1f(gpu.alpha, layer.alpha);
            gl.drawArrays(gl.TRIANGLES, 0, 6);
        }
        v.scene.context.drawImage(gpuCanvas, 0, 0);
        return true;
    }
    function queueGpu() {
        if (gpuAttempted || gpuIdle || disposed || !ready || document.hidden || print.matches || printing || !v.visible) return;
        const run = ()=>{
            gpuIdle = 0;
            if (disposed || document.hidden || print.matches || printing || !v.visible) return;
            gpuAttempted = true;
            gl = gpuCanvas.getContext('webgl', {
                alpha: true,
                antialias: false,
                premultipliedAlpha: true,
                depth: false,
                stencil: false,
                powerPreference: 'low-power'
            });
            try {
                initGpu();
            } catch  {
                gpu = null;
            }
            if (v.visible) render();
        };
        // The text and cached 2D terrain paint first; acquire the GPU only when visible.
        gpuIdle = globalThis.requestIdleCallback ? requestIdleCallback(run, {
            timeout: 1000
        }) : setTimeout(run, 150);
    }
    gpuCanvas.addEventListener('webglcontextlost', (e)=>{
        e.preventDefault();
        gpu = null;
        if (v.visible) render();
    }, {
        signal: signal
    });
    gpuCanvas.addEventListener('webglcontextrestored', ()=>{
        if (disposed) return;
        try {
            initGpu();
        } catch  {
            gpu = null;
        }
        if (v.visible) render();
    }, {
        signal: signal
    });
    function readPalette(v) {
        const css = getComputedStyle(hero);
        v.palette = {
            ink: css.color,
            wire: css.getPropertyValue('--loss-wire').trim(),
            teal: '#00e6c3'
        };
        v.paletteDirty = false;
        v.titleDirty = true;
    }
    function world(c, v) {
        c.setTransform(v.view.ratio, 0, 0, v.view.ratio, -v.view.left * v.view.ratio, 0);
    }
    function buildTitle(v) {
        const c = v.title.context;
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.clearRect(0, 0, v.view.pixelWidth, v.view.pixelHeight);
        world(c, v);
        c.fillStyle = v.palette.ink;
        // Keep exactly the same uniform glyph scale and baseline as the SVG shell.
        const titleScale = v.view.titleScale;
        c.translate(v.view.mobile ? 210 : 600 - 550 * titleScale, 240 + 45 * titleScale);
        const scale = (v.view.mobile ? .7347119 : 1.0361322) * titleScale;
        c.scale(scale, scale);
        c.fill(titlePath);
        v.titleDirty = false;
    }
    function buildBands(v) {
        v.bands = v.design.layers.map((layer)=>{
            const result = [], first = Math.ceil((layer.horizon + layer.rise * .22) * v.view.ratio), last = Math.floor((layer.horizon + layer.rise) * v.view.ratio);
            for(let row = first; row < last; row++){
                const y0 = row / v.view.ratio, y1 = (row + 1) / v.view.ratio, p0 = (y0 - layer.horizon) / layer.rise, p1 = (y1 - layer.horizon) / layer.rise, mid = (p0 + p1) / 2;
                const z0 = focal * (1 / p0 - 1), z1 = focal * (1 / p1 - 1), z = (z0 + z1) / 2, x = layer.vp + (-layer.offset + .08 * z) * mid;
                const alpha = layer.alpha * smooth(clamp((mid - .22) / .18)) * smooth(clamp((1 - mid) / .085));
                result.push({
                    x: x,
                    y0: y0,
                    height: y1 - y0,
                    p: mid,
                    z0: z0,
                    z1: z1,
                    alpha: alpha
                });
            }
            return result;
        });
    }
    function resize() {
        resizeRaf = 0;
        if (disposed) return;
        const { width: cssWidth, height: cssHeight } = stage.getBoundingClientRect();
        if (!cssWidth || !cssHeight) return;
        const mobile = mobileMedia.matches, height = mobile ? 470 : 480;
        // Once CSS caps the hero height, widen the world around its existing center.
        // The title and terrain retain their scale rather than stretching sideways.
        const width = cssWidth / cssHeight * height, left = 600 - width / 2;
        // Match the centered SVG shell; the landscape can keep widening independently.
        const titleScale = (0, $4ACxo.mastheadTitleScale)(stage, cssHeight / height, mobile ? 840 : 1200);
        // Budget total pixels rather than width so panoramic screens stay sharp
        // without increasing the previous maximum canvas area.
        const dpr = Math.min(window.devicePixelRatio || 1, 2, Math.sqrt(943104 / (cssWidth * cssHeight)));
        const pixelWidth = Math.round(cssWidth * dpr), pixelHeight = Math.round(pixelWidth * height / width);
        if (pixelWidth !== v.view.pixelWidth || pixelHeight !== v.view.pixelHeight || mobile !== v.view.mobile) {
            v.view = {
                width: width,
                height: height,
                left: left,
                ratio: pixelWidth / width,
                pixelWidth: pixelWidth,
                pixelHeight: pixelHeight,
                mobile: mobile,
                titleScale: titleScale
            };
            for (const canvas of [
                v.canvas,
                v.scene.element,
                v.title.element
            ]){
                canvas.width = pixelWidth;
                canvas.height = pixelHeight;
            }
            v.titleDirty = true;
            buildBands(v);
        }
        if (v.visible) render();
        schedule();
    }
    function queueResize() {
        if (!resizeRaf && !disposed) resizeRaf = requestAnimationFrame(resize);
    }
    function point(layer, x, z) {
        const p = focal / (focal + z);
        return [
            layer.vp + (x - layer.offset + .08 * z) * p,
            layer.horizon + layer.rise * p,
            p
        ];
    }
    function depthAlpha(z) {
        const p = focal / (focal + z);
        return smooth(clamp((p - .22) / .18)) * smooth(clamp((1 - p) / .085));
    }
    function sampleTrack(track, distance) {
        const s = clamp(distance, 0, track.length), lengths = track.cumulative;
        let lo = 0, hi = lengths.length - 1;
        while(lo + 1 < hi){
            const mid = lo + hi >> 1;
            if (lengths[mid] <= s) lo = mid;
            else hi = mid;
        }
        const a = track.points[lo], b = track.points[lo + 1], t = (s - lengths[lo]) / (lengths[lo + 1] - lengths[lo]);
        return [
            a[0] + (b[0] - a[0]) * t,
            a[1] + (b[1] - a[1]) * t
        ];
    }
    function particleState(v, layer, serial, xcopy) {
        const tracks = fields[layer.field].tracks, track = tracks[mod(serial + xcopy + layer.field, tracks.length)];
        const steps = track.stops.length - 1, cadence = v.state.cadence * (layer.field === 1 ? 1.11 : 1), duration = steps * cadence, cycle = duration + 4;
        const time = mod(v.elapsed + cycle * mod(layer.phase + serial * .31 + xcopy * .19, 1), cycle), settled = time >= duration;
        const index = Math.min(steps - 1, Math.floor(time / cadence)), phase = settled ? 1 : mod(time / cadence, 1);
        const progress = settled ? 1 : smooth(clamp((phase - .34) / .57));
        const distance = track.stops[index] + (track.stops[index + 1] - track.stops[index]) * progress;
        const fade = smooth(clamp(time / .8)) * smooth(clamp((cycle - time) / 1.1));
        return {
            track: track,
            time: time,
            settled: settled,
            index: index,
            phase: phase,
            distance: distance,
            fade: fade
        };
    }
    function drawParticle(c, v, layer, serial, xcopy) {
        const { track: track, settled: settled, index: index, phase: phase, distance: distance, fade: fade } = particleState(v, layer, serial, xcopy);
        const surface = sampleTrack(track, distance), shift = serial * wrapZ + v.travel * layer.pace, z = surface[1] + shift;
        if (z < 0 || z > focal * (1 / .22 - 1)) return;
        const alpha = layer.alpha * depthAlpha(z) * fade;
        if (alpha < .025) return;
        const p = point(layer, surface[0] + xcopy * wrapX, z);
        if (p[0] < v.view.left - 110 || p[0] > v.view.left + v.view.width + 110) return;
        const projectAt = (s)=>{
            const q = sampleTrack(track, s);
            return point(layer, q[0] + xcopy * wrapX, q[1] + shift);
        };
        // The short wake follows the precomputed negative-gradient trajectory.
        c.strokeStyle = '#fff';
        c.fillStyle = '#fff';
        c.lineCap = 'round';
        c.lineJoin = 'round';
        const wake = Math.min(145, distance), wakeSegments = 12;
        let previous = projectAt(distance - wake);
        for(let i = 1; i <= wakeSegments; i++){
            const q = projectAt(distance - wake * (1 - i / wakeSegments));
            c.globalAlpha = alpha * .8 * (i / wakeSegments) ** 1.6;
            c.lineWidth = 3.1;
            c.beginPath();
            c.moveTo(previous[0], previous[1]);
            c.lineTo(q[0], q[1]);
            c.stroke();
            previous = q;
        }
        // Preview only the next downhill step; it naturally shrinks near the basin.
        const arrowAlpha = settled ? 0 : clamp((phase - .12) / .14) * clamp((.80 - phase) / .18);
        const ahead = track.stops[index + 1] - distance, end = projectAt(track.stops[index + 1]);
        const screenReach = Math.hypot(end[0] - p[0], end[1] - p[1]);
        if (arrowAlpha > 0 && screenReach > 12 && ahead > 0) {
            const samples = 10, gap = Math.min(ahead * .25, 13 / Math.max(.25, p[2]));
            let last = p, tip = p;
            c.globalAlpha = alpha * arrowAlpha;
            c.lineWidth = 2.5;
            c.beginPath();
            for(let i = 0; i <= samples; i++){
                const q = projectAt(distance + gap + (ahead - gap) * i / samples);
                if (i === 0) c.moveTo(q[0], q[1]);
                else c.lineTo(q[0], q[1]);
                last = tip;
                tip = q;
            }
            c.stroke();
            const d = Math.max(.001, Math.hypot(tip[0] - last[0], tip[1] - last[1])), vx = (tip[0] - last[0]) / d, vy = (tip[1] - last[1]) / d, head = Math.min(8, screenReach * .25);
            c.beginPath();
            c.moveTo(tip[0] - head * vx + head * .5 * vy, tip[1] - head * vy - head * .5 * vx);
            c.lineTo(tip[0], tip[1]);
            c.lineTo(tip[0] - head * vx - head * .5 * vy, tip[1] - head * vy + head * .5 * vx);
            c.stroke();
        }
        const pulse = clamp(phase / .22), pulsing = !settled && phase < .22, radius = 5.5 + 3 * p[2] + (pulsing ? Math.sin(pulse * Math.PI) * 1.6 : 0);
        c.globalAlpha = alpha * (pulsing ? (1 - pulse) * .7 : settled ? .3 : .07);
        c.lineWidth = 1.4;
        c.beginPath();
        c.arc(p[0], p[1], pulsing ? 10 + 18 * pulse : 13, 0, Math.PI * 2);
        c.stroke();
        c.globalCompositeOperation = 'destination-out';
        c.globalAlpha = alpha;
        c.lineWidth = 2.2;
        c.beginPath();
        c.arc(p[0], p[1], radius, 0, Math.PI * 2);
        c.stroke();
        c.globalCompositeOperation = 'source-over';
        c.globalAlpha = alpha;
        c.beginPath();
        c.arc(p[0], p[1], radius, 0, Math.PI * 2);
        c.fill();
    }
    function draw(v) {
        if (disposed || !v.view.pixelWidth) return;
        if (v.paletteDirty) readPalette(v);
        if (v.titleDirty) buildTitle(v);
        const c = v.scene.context, { pixelWidth: pixelWidth, pixelHeight: pixelHeight, ratio: ratio, left: left, width: width } = v.view;
        const dx = 0, dy = 0;
        if (reduced.matches) v.revealElapsed = .8;
        const reveal = smooth(clamp(v.revealElapsed / .8));
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.globalCompositeOperation = 'source-over';
        c.globalAlpha = 1;
        c.clearRect(0, 0, pixelWidth, pixelHeight);
        const gpuDrawn = drawTerrain(v);
        queueGpu();
        v.design.layers.forEach((layer, li)=>{
            if (!gpuDrawn) {
                const tile = getField(layer.field, 1024);
                let pattern = tile.patterns.get(c);
                if (!pattern) {
                    pattern = c.createPattern(tile.element, 'repeat');
                    tile.patterns.set(c, pattern);
                }
                c.fillStyle = pattern;
                for (const b of v.bands[li]){
                    const scroll = mod(v.travel * layer.pace, wrapZ), sx = wrapX / tile.width * b.p, sy = b.height / ((b.z1 - b.z0) / wrapZ * tile.height), sourceY = (b.z0 - scroll) / wrapZ * tile.height;
                    c.setTransform(ratio * sx, 0, 0, ratio * sy, (b.x - left) * ratio, (b.y0 - sourceY * sy) * ratio);
                    c.globalAlpha = b.alpha;
                    c.fillRect((left - b.x) / sx, sourceY, width / sx, (b.z1 - b.z0) / wrapZ * tile.height);
                }
            }
            world(c, v);
            const lap = Math.floor(v.travel * layer.pace / wrapZ);
            for(let copy = -2; copy <= 3; copy++)for(let xcopy = -2; xcopy <= 2; xcopy++)drawParticle(c, v, layer, copy - lap, xcopy);
        });
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.globalAlpha = 1;
        c.globalCompositeOperation = 'source-in';
        c.fillStyle = v.palette.wire;
        c.fillRect(0, 0, pixelWidth, pixelHeight);
        v.ctx.setTransform(1, 0, 0, 1, 0, 0);
        v.ctx.clearRect(0, 0, pixelWidth, pixelHeight);
        v.ctx.globalAlpha = v.state.background * reveal;
        v.ctx.drawImage(v.scene.element, dx, dy);
        // Cut background wires out of the letters, leaving the persistent SVG ink
        // below untouched. Only the teal overlap is composited over that title.
        v.ctx.globalAlpha = 1;
        v.ctx.globalCompositeOperation = 'destination-out';
        v.ctx.drawImage(v.title.element, 0, 0);
        v.ctx.globalCompositeOperation = 'source-over';
        c.fillStyle = v.palette.teal;
        c.fillRect(0, 0, pixelWidth, pixelHeight);
        c.globalCompositeOperation = 'destination-in';
        c.drawImage(v.title.element, -dx, -dy);
        v.ctx.globalAlpha = reveal;
        v.ctx.drawImage(v.scene.element, dx, dy);
        v.ctx.globalAlpha = 1;
    }
    // A failed canvas enhancement leaves the outlined SVG shell in place.
    function render() {
        if (disposed || !ready || !v.view.pixelWidth || print.matches || printing) return;
        try {
            draw(v);
            stage.classList.add('loss-contour-ready');
        } catch  {
            dispose();
        }
    }
    function runnable() {
        return ready && !reduced.matches && v.visible && !document.hidden && !print.matches && !printing && !suspended && !disposed;
    }
    function frame(now) {
        v.raf = 0;
        if (!hero.isConnected) {
            dispose();
            return;
        }
        if (!runnable()) return;
        const dt = v.last ? Math.min((now - v.last) / 1000, .1) : 0;
        v.last = now;
        v.travel += dt * v.state.speed;
        v.elapsed += dt;
        v.revealElapsed = Math.min(.8, v.revealElapsed + dt);
        if (now + .5 >= v.nextDraw) {
            render();
            const interval = 1000 / (v.view.mobile ? 24 : 30);
            v.nextDraw += interval;
            if (v.nextDraw < now - interval) v.nextDraw = now + interval;
        }
        if (runnable()) v.raf = requestAnimationFrame(frame);
    }
    function schedule() {
        cancelAnimationFrame(v.raf);
        v.raf = 0;
        v.last = 0;
        v.nextDraw = performance.now();
        if (runnable()) v.raf = requestAnimationFrame(frame);
    }
    const resizeObserver = new ResizeObserver(queueResize);
    resizeObserver.observe(stage);
    const intersection = new IntersectionObserver(([entry])=>{
        if (!hero.isConnected) {
            dispose();
            return;
        }
        v.visible = entry.isIntersecting;
        if (v.visible) resize();
        else schedule();
    }, {
        threshold: .01
    });
    intersection.observe(stage);
    function themeChanged() {
        v.paletteDirty = true;
        if (v.visible) render();
    }
    const themeObserver = new MutationObserver(themeChanged);
    for (const node of [
        document.documentElement,
        document.body
    ])themeObserver.observe(node, {
        attributes: true,
        attributeFilter: [
            'class',
            'style',
            'data-theme',
            'data-color-mode'
        ]
    });
    dark.addEventListener('change', themeChanged, {
        signal: signal
    });
    reduced.addEventListener('change', ()=>{
        if (v.visible) render();
        schedule();
    }, {
        signal: signal
    });
    mobileMedia.addEventListener('change', queueResize, {
        signal: signal
    });
    print.addEventListener('change', ()=>{
        if (!print.matches) queueResize();
        schedule();
    }, {
        signal: signal
    });
    document.addEventListener('visibilitychange', ()=>{
        if (!document.hidden) queueResize();
        schedule();
    }, {
        signal: signal
    });
    window.addEventListener('resize', queueResize, {
        signal: signal
    });
    window.addEventListener('beforeprint', ()=>{
        printing = true;
        schedule();
    }, {
        signal: signal
    });
    window.addEventListener('afterprint', ()=>{
        printing = false;
        queueResize();
        schedule();
    }, {
        signal: signal
    });
    window.addEventListener('pagehide', (event)=>{
        if (!event.persisted) {
            dispose();
            return;
        }
        suspended = true;
        schedule();
    }, {
        signal: signal
    });
    window.addEventListener('pageshow', ()=>{
        suspended = false;
        queueResize();
        schedule();
    }, {
        signal: signal
    });
    let dprMedia;
    function watchDpr() {
        dprMedia?.removeEventListener('change', dprChanged);
        dprMedia = matchMedia(`(resolution: ${window.devicePixelRatio || 1}dppx)`);
        dprMedia.addEventListener('change', dprChanged, {
            once: true
        });
    }
    function dprChanged() {
        watchDpr();
        queueResize();
    }
    function dispose() {
        if (disposed) return;
        disposed = true;
        abort.abort();
        cancelAnimationFrame(v.raf);
        cancelAnimationFrame(resizeRaf);
        if (gpuIdle) {
            if (globalThis.cancelIdleCallback) cancelIdleCallback(gpuIdle);
            else clearTimeout(gpuIdle);
        }
        resizeObserver.disconnect();
        intersection.disconnect();
        themeObserver.disconnect();
        dprMedia?.removeEventListener('change', dprChanged);
        for (const surface of [
            scene,
            title
        ])surface.element.width = surface.element.height = 1;
        for (const cache of caches.values())cache.element.width = cache.element.height = 1;
        caches.clear();
        if (gpu) {
            for (const texture of gpu.textures.values())gl.deleteTexture(texture);
            gl.deleteBuffer(gpu.buffer);
            gl.deleteProgram(gpu.program);
            gpu = null;
        }
        gpuCanvas.width = gpuCanvas.height = 1;
        gl?.getExtension('WEBGL_lose_context')?.loseContext();
        canvas.remove();
        stage.classList.remove('loss-contour-ready');
    }
    watchDpr();
    resize();
    // Outlines need no font download; reveal only after the first complete draw.
    Promise.resolve().then(()=>{
        if (disposed) return;
        ready = true;
        v.titleDirty = true;
        resize();
    }).catch(dispose);
    return {
        dispose: dispose
    };
}


const $8a51b9e8cb930481$var$hero = document.querySelector('.wireframe-hero');
if ($8a51b9e8cb930481$var$hero) (0, $d35456265291abd0$export$ccb823308650f28)($8a51b9e8cb930481$var$hero);


//# sourceMappingURL=frontend.c18d5ed1.js.map
